import { ExerciseCategory } from '../shared-library/exercise-categories';
import { ExerciseSubcategory } from '../shared-library/exercise-categories';
import { UnitType } from '../utils/api-utils';
import gql from 'graphql-tag';
import * as Urql from '../api/urql/urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ConstrainedInt__min_0: number;
  ConstrainedInt__min_1__max_64: number;
  ConstrainedInt__min_1__max_1000: number;
  ConstrainedInt__min_1__max_2147483647: number;
  ConstrainedString__min_1__max_60__trim: string;
  ConstrainedString__min_1__trim: string;
  ConstrainedString__trim: string;
  ConstrainedString__uuidV4: string;
  Date: string;
  JSON: unknown;
  JSONObject: object;
  ListOrder: string;
};

export type TActivationCode = TNode & {
  __typename: 'ActivationCode';
  codeUsers: TUserConnection;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  maxUseCount: Scalars['Int'];
  /** whether this code was manually disabled to prevent further usage. */
  revoked: Scalars['Boolean'];
  value: Scalars['String'];
};


export type TActivationCodeCodeUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TActivationCodeConnection = {
  __typename: 'ActivationCodeConnection';
  nodes: Array<TActivationCode>;
  pageInfo: TPageInfo;
  totalCount: Scalars['Int'];
};

export type TActivationCodeFolder = TNode & {
  __typename: 'ActivationCodeFolder';
  author: TUser;
  codeUsers: TUserConnection;
  codes: TActivationCodeConnection;
  /** whether all codes in this folder were manually disabled to prevent further usage. */
  codesRevoked: Revoked;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  maxUseCount: Scalars['Int'];
  name: Scalars['String'];
};


export type TActivationCodeFolderCodeUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TActivationCodeFolderCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TActivationCodeFolderConnection = {
  __typename: 'ActivationCodeFolderConnection';
  nodes: Array<TActivationCodeFolder>;
  pageInfo: TPageInfo;
  totalCount: Scalars['Int'];
};

export type TAddChallengeError = {
  __typename: 'AddChallengeError';
  code: AddChallengeErrorCode;
  message: Scalars['String'];
};

export enum AddChallengeErrorCode {
  ErrEndDateTooFar = 'ERR_END_DATE_TOO_FAR',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ErrNoOccurrences = 'ERR_NO_OCCURRENCES',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND',
  InvalidRruleSyntax = 'INVALID_RRULE_SYNTAX'
}

export type TAddChallengeInput = {
  amount: Scalars['ConstrainedInt__min_1__max_2147483647'];
  amountUnit: UnitType;
  category: ExerciseCategory;
  exercise: Scalars['ID'];
  extraInstructions: Scalars['String'];
  rrule: Scalars['String'];
  series: Scalars['ConstrainedInt__min_1__max_64'];
};

export type TAddChallengePayload = {
  __typename: 'AddChallengePayload';
  error?: Maybe<TAddChallengeError>;
  node?: Maybe<TChallenge>;
};

export type TAddChallengeTemplateToPackError = {
  __typename: 'AddChallengeTemplateToPackError';
  code: AddChallengeTemplateToPackErrorCode;
  message: Scalars['String'];
};

export enum AddChallengeTemplateToPackErrorCode {
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ErrNoOccurrences = 'ERR_NO_OCCURRENCES',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND',
  PackNotFound = 'PACK_NOT_FOUND'
}

export type TAddChallengeTemplateToPackInput = {
  amount: Scalars['ConstrainedInt__min_1__max_2147483647'];
  amountUnit: UnitType;
  category: ExerciseCategory;
  exercise: Scalars['ID'];
  extraInstructions: Scalars['ConstrainedString__trim'];
  pack: Scalars['ID'];
  scheduleTemplate: Array<Scalars['JSONObject']>;
  serialDay?: InputMaybe<Scalars['ConstrainedInt__min_1__max_2147483647']>;
  serialDayIndex?: InputMaybe<Scalars['Int']>;
  series: Scalars['ConstrainedInt__min_1__max_64'];
};

export type TAddChallengeTemplateToPackPayload = {
  __typename: 'AddChallengeTemplateToPackPayload';
  error?: Maybe<TAddChallengeTemplateToPackError>;
  node?: Maybe<TChallengeTemplate>;
};

export type TAddMemberToGroupError = {
  __typename: 'AddMemberToGroupError';
  code: AddMemberToGroupErrorCode;
  message: Scalars['String'];
};

export enum AddMemberToGroupErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type TAddMemberToGroupInput = {
  group: Scalars['ID'];
  userIdOrEmail: Scalars['String'];
};

export type TAddMemberToGroupPayload = {
  __typename: 'AddMemberToGroupPayload';
  error?: Maybe<TAddMemberToGroupError>;
  node?: Maybe<TGroup>;
};

export type TAddQuestionProposal = TNode & {
  __typename: 'AddQuestionProposal';
  approval: Approval;
  id: Scalars['ID'];
  patient: TUser;
  questions: Array<TQuestion>;
  rrule: Scalars['String'];
  therapist: TUser;
};

export enum AlertLevel {
  Danger = 'Danger',
  Neutral = 'Neutral',
  Warning = 'Warning'
}

export type TAnswerAddQuestionsProposalError = {
  __typename: 'AnswerAddQuestionsProposalError';
  code: AnswerAddQuestionsProposalErrorCode;
  message: Scalars['String'];
};

export enum AnswerAddQuestionsProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ProposalNotFound = 'PROPOSAL_NOT_FOUND',
  ProposalStateMismatch = 'PROPOSAL_STATE_MISMATCH'
}

export type TAnswerAddQuestionsProposalInput = {
  approved: Scalars['Boolean'];
  proposal: Scalars['ID'];
};

export type TAnswerAddQuestionsProposalPayload = {
  __typename: 'AnswerAddQuestionsProposalPayload';
  error?: Maybe<TAnswerAddQuestionsProposalError>;
  node?: Maybe<TAddQuestionProposal>;
};

export type TAnswerQuestionError = {
  __typename: 'AnswerQuestionError';
  code: AnswerQuestionErrorCode;
  message: Scalars['String'];
};

export enum AnswerQuestionErrorCode {
  DateMismatch = 'DATE_MISMATCH',
  QuestionNotFound = 'QUESTION_NOT_FOUND'
}

export type TAnswerQuestionInput = {
  /** ISO-8601 DateOnly */
  date: Scalars['String'];
  question: Scalars['ID'];
  value: Scalars['Int'];
};

export type TAnswerQuestionPayload = {
  __typename: 'AnswerQuestionPayload';
  error?: Maybe<TAnswerQuestionError>;
  node?: Maybe<TQuestionResponse>;
};

export type TAnswerQuestionsPayload = {
  __typename: 'AnswerQuestionsPayload';
  error?: Maybe<TAnswerQuestionError>;
  node?: Maybe<Array<TQuestionResponse>>;
};

export enum Approval {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum ApprovalResponse {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type TAsset = TNode & {
  __typename: 'Asset';
  createdAt: Scalars['Date'];
  formats: Array<TAssetFormat>;
  id: Scalars['ID'];
  type?: Maybe<AssetType>;
};

export type TAssetFormat = {
  __typename: 'AssetFormat';
  encoding: Scalars['String'];
  fileName: Scalars['String'];
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export enum AssetType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type TChallenge = TNode & {
  __typename: 'Challenge';
  author: TUser;
  category: ExerciseCategory;
  id: Scalars['ID'];
  patient: TUser;
  totalDone: Scalars['Int'];
  versions: Array<TChallengeVersion>;
};


export type TChallengeVersionsArgs = {
  activeAt?: InputMaybe<Scalars['String']>;
};

export type TChallengeCheckIn = {
  __typename: 'ChallengeCheckIn';
  amounts: Array<Scalars['Int']>;
  dueDate: Scalars['String'];
  feedback: Scalars['String'];
  /** nullable */
  feedbackPositive?: Maybe<Scalars['Boolean']>;
  feedbackTypes: Array<FeedbackType>;
};

export type TChallengePackShare = TNode & {
  __typename: 'ChallengePackShare';
  approval?: Maybe<Approval>;
  author: TUser;
  id: Scalars['ID'];
  pack?: Maybe<TChallengeTemplatePack>;
  packName: Scalars['String'];
  recipient: TUser;
};

export type TChallengeProposal = TIChallengeTemplate & TNode & {
  __typename: 'ChallengeProposal';
  amount: Scalars['Int'];
  amountUnit: UnitType;
  approval: Approval;
  author: TUser;
  category: ExerciseCategory;
  /**
   * the challenge created when approving this proposal
   * this becomes populated if the proposal has been approved
   */
  createdChallenge?: Maybe<TChallenge>;
  editedChallenge?: Maybe<TChallenge>;
  /**
   * iso date-only string, nullable
   * @deprecated use scheduleTemplate instead, there is no real end date until the proposal has been accepted
   */
  endDate?: Maybe<Scalars['String']>;
  exercise: TExercise;
  extraInstructions: Scalars['String'];
  id: Scalars['ID'];
  patient: TUser;
  /** @deprecated use scheduleTemplate instead, there is no real end date until the proposal has been accepted */
  rrule: Scalars['String'];
  /**
   * The schedule template, which will be used to build the corresponding RRule once the challenge becomes live.
   * Can be null if this is a challenge edition proposal that does not modify the schedule of the existing challenge.
   */
  scheduleTemplate?: Maybe<Array<Scalars['JSONObject']>>;
  serialDay?: Maybe<Scalars['Int']>;
  serialDayIndex?: Maybe<Scalars['Int']>;
  series: Scalars['Int'];
  /**
   * iso date-only string
   * @deprecated use scheduleTemplate instead, there is no real start date until the proposal has been accepted
   */
  startDate: Scalars['String'];
};

export type TChallengeProposalMessage = TMessage & TNode & {
  __typename: 'ChallengeProposalMessage';
  challengeProposals: Array<TChallengeProposal>;
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  sentAt: Scalars['Date'];
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TChallengeTemplate = TIChallengeTemplate & TNode & {
  __typename: 'ChallengeTemplate';
  amount: Scalars['Int'];
  amountUnit: UnitType;
  author: TUser;
  category: ExerciseCategory;
  exercise: TExercise;
  extraInstructions: Scalars['String'];
  id: Scalars['ID'];
  scheduleTemplate: Array<Scalars['JSONObject']>;
  serialDay?: Maybe<Scalars['Int']>;
  serialDayIndex?: Maybe<Scalars['Int']>;
  series: Scalars['Int'];
};

export type TChallengeTemplatePack = TNode & {
  __typename: 'ChallengeTemplatePack';
  archived: Scalars['Boolean'];
  author: TUser;
  challenges: Array<TChallengeTemplate>;
  codeFolders: TActivationCodeFolderConnection;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sharePending: Scalars['Boolean'];
  type: ChallengeTemplatePackTypes;
};


export type TChallengeTemplatePackCodeFoldersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};

export enum ChallengeTemplatePackTypes {
  Scheduled = 'scheduled',
  Serial = 'serial'
}

export type TChallengeVersion = {
  __typename: 'ChallengeVersion';
  amount: Scalars['Int'];
  amountUnit: UnitType;
  author: TUser;
  checkIns: Array<TChallengeCheckIn>;
  /** endDate is null if the challenge never ends */
  endDate?: Maybe<Scalars['String']>;
  exercise: TExercise;
  extraInstructions: Scalars['String'];
  /**
   * The complete RRule since the creation of the challenge, including historical versions
   * use this RRule to determine every dates where the challenge was planned
   *
   * {historicalRRule} can be the empty string if it was removed from the schedule before any occurrence could happen.
   */
  historicalRRule: Scalars['String'];
  /**
   * The latest version of the RRule
   * use this RRule as a base to display a widget to edit the planning of this challenge
   *
   * {lastRRule} can be the empty string if it was removed from the schedule before any occurrence could happen.
   */
  lastRRule: Scalars['String'];
  patient: TUser;
  series: Scalars['Int'];
  /** startDate is null if it was removed from the schedule before any occurrence could happen. */
  startDate?: Maybe<Scalars['String']>;
  versionIndex: Scalars['Int'];
};


export type TChallengeVersionCheckInsArgs = {
  dates: Scalars['String'];
};

export type TCoachingProposalMessage = TMessage & TNode & {
  __typename: 'CoachingProposalMessage';
  coachingProposal: TCoachingSubscription;
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  sentAt: Scalars['Date'];
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TCoachingSubscription = TNode & {
  __typename: 'CoachingSubscription';
  approval: Approval;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  patient: TUser;
  patientTotalPrice: Scalars['Int'];
  recurrence: TCoachingSubscriptionRecurrence;
  therapist: TUser;
};

/** represents a repetition: "every {interval} {frequency}" (eg. "every 2 weeks", "every 1 month"). */
export type TCoachingSubscriptionRecurrence = {
  __typename: 'CoachingSubscriptionRecurrence';
  frequency: FrequencyType;
  interval: Scalars['Int'];
};

export type TCodeOrFolder = TActivationCode | TActivationCodeFolder;

export type TConfigurePatientAlertsError = {
  __typename: 'ConfigurePatientAlertsError';
  code: ConfigurePatientAlertsErrorCode;
  message: Scalars['String'];
};

export enum ConfigurePatientAlertsErrorCode {
  PatientNotFound = 'PATIENT_NOT_FOUND',
  ViewerNotTherapist = 'VIEWER_NOT_THERAPIST'
}

export type TConfigurePatientAlertsPayload = {
  __typename: 'ConfigurePatientAlertsPayload';
  error?: Maybe<TConfigurePatientAlertsError>;
  node?: Maybe<TTherapistAlertConfig>;
};

export type TConversation = TNode & {
  __typename: 'Conversation';
  contact: TUser;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  /** See Query.messages for documentation. */
  messages: TMessageConnection;
  /**
   * null if all messages have been read or there are visible messages
   * Used to jump the viewer to this message when they open a conversation.
   */
  oldestUnreadMessage?: Maybe<TMessage>;
};


export type TConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TConversationConnection = {
  __typename: 'ConversationConnection';
  nodes: Array<TConversation>;
  pageInfo: TPageInfo;
  totalCount: Scalars['Int'];
};

export type TConversationEdge = {
  __typename: 'ConversationEdge';
  cursor: Scalars['String'];
  node: TConversation;
};

export type TCopyChallengeTemplatePackError = {
  __typename: 'CopyChallengeTemplatePackError';
  code: CopyChallengeTemplatePackErrorCode;
  message: Scalars['String'];
};

export enum CopyChallengeTemplatePackErrorCode {
  PackNotFound = 'PACK_NOT_FOUND',
  AccessDenied = 'ACCESS_DENIED'
}

export type TCopyChallengeTemplatePackInput = {
  description: Scalars['ConstrainedString__trim'];
  name: Scalars['ConstrainedString__min_1__max_60__trim'];
  pack: Scalars['ID'];
  /**
   * Ignored: a copy keeps the type of its source. Accepted because fronts built before pack sharing
   * (#7), iOS 0.23.1 included, still send it, and GraphQL rejects an input field it does not know.
   */
  type?: InputMaybe<ChallengeTemplatePackTypes>;
};

export type TCopyChallengeTemplatePackPayload = {
  __typename: 'CopyChallengeTemplatePackPayload';
  error?: Maybe<TCopyChallengeTemplatePackError>;
  node?: Maybe<TChallengeTemplatePack>;
};

export type TCreateAddChallengeProposalError = {
  __typename: 'CreateAddChallengeProposalError';
  code: CreateAddChallengeProposalErrorCode;
  message: Scalars['String'];
};

export enum CreateAddChallengeProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ErrNoOccurrences = 'ERR_NO_OCCURRENCES',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND',
  PatientNotFound = 'PATIENT_NOT_FOUND'
}

export type TCreateAddChallengeProposalInput = {
  amount: Scalars['ConstrainedInt__min_1__max_2147483647'];
  amountUnit: UnitType;
  category: ExerciseCategory;
  exercise: Scalars['ID'];
  extraInstructions: Scalars['ConstrainedString__trim'];
  patients: Array<Scalars['String']>;
  /** JSON-serialised TScheduleTemplate objects */
  scheduleTemplate: Array<Scalars['JSONObject']>;
  series: Scalars['ConstrainedInt__min_1__max_64'];
};

export type TCreateAddChallengeProposalPayload = {
  __typename: 'CreateAddChallengeProposalPayload';
  error?: Maybe<TCreateAddChallengeProposalError>;
  node?: Maybe<Array<TChallengeProposal>>;
};

export type TCreateChallengeTemplatePackError = {
  __typename: 'CreateChallengeTemplatePackError';
  code: CreateChallengeTemplatePackErrorCode;
  message: Scalars['String'];
};

export enum CreateChallengeTemplatePackErrorCode {
  ViewerNotTherapist = 'VIEWER_NOT_THERAPIST'
}

export type TCreateChallengeTemplatePackInput = {
  description: Scalars['ConstrainedString__trim'];
  name: Scalars['ConstrainedString__min_1__max_60__trim'];
  /** Fronts built before serial packs do not send it: they only create scheduled packs. */
  type?: ChallengeTemplatePackTypes;
};

export type TCreateChallengeTemplatePackPayload = {
  __typename: 'CreateChallengeTemplatePackPayload';
  error?: Maybe<TCreateChallengeTemplatePackError>;
  node?: Maybe<TChallengeTemplatePack>;
};

export type TCreateEditChallengeProposalError = {
  __typename: 'CreateEditChallengeProposalError';
  code: CreateEditChallengeProposalErrorCode;
  message: Scalars['String'];
};

export enum CreateEditChallengeProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND'
}

export type TCreateEditChallengeProposalInput = {
  amount: Scalars['Int'];
  challengeId: Scalars['ID'];
  exercise: Scalars['ID'];
  extraInstructions: Scalars['String'];
  /**
   * JSON-serialised TScheduleTemplate objects
   * can be null if no changes should be applied once the patient accepts the proposal
   */
  scheduleTemplate?: InputMaybe<Array<Scalars['JSONObject']>>;
  series: Scalars['Int'];
};

export type TCreateEditChallengeProposalPayload = {
  __typename: 'CreateEditChallengeProposalPayload';
  error?: Maybe<TUpdateAddChallengeProposalError>;
  node?: Maybe<TChallengeProposal>;
};

export type TCreateGroupError = {
  __typename: 'CreateGroupError';
  code: CreateGroupErrorCode;
  message: Scalars['String'];
};

export enum CreateGroupErrorCode {
  AccessDenied = 'ACCESS_DENIED'
}

export type TCreateGroupInput = {
  name: Scalars['ConstrainedString__min_1__trim'];
  organisation: Scalars['ID'];
};

export type TCreateGroupPayload = {
  __typename: 'CreateGroupPayload';
  error?: Maybe<TCreateGroupError>;
  node?: Maybe<TGroup>;
};

export type TCreateOrganisationError = {
  __typename: 'CreateOrganisationError';
  code: CreateOrganisationErrorCode;
  message: Scalars['String'];
};

export enum CreateOrganisationErrorCode {
  /** currently only a MyMedicoach administrator can create organisations */
  AccessDenied = 'ACCESS_DENIED'
}

export type TCreateOrganisationInput = {
  name: Scalars['ConstrainedString__min_1__trim'];
};

export type TCreateOrganisationPayload = {
  __typename: 'CreateOrganisationPayload';
  error?: Maybe<TCreateOrganisationError>;
  node?: Maybe<TOrganisation>;
};

export type TCreateUserProviderInput = {
  providerName: Scalars['String'];
  providerUserId: Scalars['String'];
  providerUserType: Scalars['String'];
};

export type TCreateUserProviderPayload = {
  __typename: 'CreateUserProviderPayload';
  error?: Maybe<TUserProviderError>;
  node?: Maybe<TUserProvider>;
};

export type TDeleteGroupError = {
  __typename: 'DeleteGroupError';
  code: DeleteGroupErrorCode;
  message: Scalars['String'];
};

export enum DeleteGroupErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  /**
   * This code is returned if it is impossible to delete this group
   * as doing so would leave the organisation with 0 groups able
   * to modify groups.
   */
  LastAdminGroup = 'LAST_ADMIN_GROUP'
}

export type TDeleteGroupInput = {
  group: Scalars['ID'];
};

export type TDeleteGroupPayload = {
  __typename: 'DeleteGroupPayload';
  error?: Maybe<TDeleteGroupError>;
};

export type TDeleteOrganisationError = {
  __typename: 'DeleteOrganisationError';
  code: EditOrganisationErrorCode;
  message: Scalars['String'];
};

export enum DeleteOrganisationErrorCode {
  /** currently only a MyMedicoach administrator can delete organisations */
  AccessDenied = 'ACCESS_DENIED'
}

export type TDeleteOrganisationInput = {
  organisation: Scalars['ID'];
};

export type TDeleteOrganisationPayload = {
  __typename: 'DeleteOrganisationPayload';
  error?: Maybe<TDeleteOrganisationError>;
};

export type TEditChallengeError = {
  __typename: 'EditChallengeError';
  code: EditChallengeErrorCode;
  message: Scalars['String'];
};

export enum EditChallengeErrorCode {
  ChallengeNotFound = 'CHALLENGE_NOT_FOUND',
  ErrEndDateTooFar = 'ERR_END_DATE_TOO_FAR',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND',
  InvalidRruleSyntax = 'INVALID_RRULE_SYNTAX'
}

export type TEditChallengeInput = {
  amount?: InputMaybe<Scalars['ConstrainedInt__min_1__max_2147483647']>;
  challenge: Scalars['ID'];
  exercise?: InputMaybe<Scalars['ID']>;
  extraInstructions?: InputMaybe<Scalars['String']>;
  /** set to "" to stop the challenge immediately */
  rrule?: InputMaybe<Scalars['String']>;
  series?: InputMaybe<Scalars['ConstrainedInt__min_1__max_64']>;
};

export type TEditChallengePayload = {
  __typename: 'EditChallengePayload';
  error?: Maybe<TEditChallengeError>;
  node?: Maybe<TChallenge>;
};

export type TEditChallengeTemplateError = {
  __typename: 'EditChallengeTemplateError';
  code: EditChallengeTemplateErrorCode;
  message: Scalars['String'];
};

export enum EditChallengeTemplateErrorCode {
  ChallengeTemplateNotFound = 'CHALLENGE_TEMPLATE_NOT_FOUND',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ErrNoOccurrences = 'ERR_NO_OCCURRENCES',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND'
}

export type TEditChallengeTemplateInput = {
  amount?: InputMaybe<Scalars['ConstrainedInt__min_1__max_2147483647']>;
  amountUnit?: InputMaybe<UnitType>;
  category?: InputMaybe<ExerciseCategory>;
  challengeTemplate: Scalars['ID'];
  exercise?: InputMaybe<Scalars['ID']>;
  extraInstructions?: InputMaybe<Scalars['ConstrainedString__trim']>;
  scheduleTemplate?: InputMaybe<Array<Scalars['JSONObject']>>;
  serialDay?: InputMaybe<Scalars['ConstrainedInt__min_1__max_2147483647']>;
  serialDayIndex?: InputMaybe<Scalars['Int']>;
  series?: InputMaybe<Scalars['ConstrainedInt__min_1__max_64']>;
};

export type TEditChallengeTemplatePackError = {
  __typename: 'EditChallengeTemplatePackError';
  code: EditChallengeTemplatePackErrorCode;
  message: Scalars['String'];
};

export enum EditChallengeTemplatePackErrorCode {
  ErrSerialPackAlreadyProposed = 'ERR_SERIAL_PACK_ALREADY_PROPOSED',
  PackNotFound = 'PACK_NOT_FOUND'
}

export type TEditChallengeTemplatePackInput = {
  description?: InputMaybe<Scalars['ConstrainedString__trim']>;
  name?: InputMaybe<Scalars['ConstrainedString__min_1__max_60__trim']>;
  pack: Scalars['ID'];
};

export type TEditChallengeTemplatePackPayload = {
  __typename: 'EditChallengeTemplatePackPayload';
  error?: Maybe<TEditChallengeTemplatePackError>;
  node?: Maybe<TChallengeTemplatePack>;
};

export type TEditChallengeTemplatePayload = {
  __typename: 'EditChallengeTemplatePayload';
  error?: Maybe<TEditChallengeTemplateError>;
  node?: Maybe<TChallengeTemplate>;
};

export type TEditGroupError = {
  __typename: 'EditGroupError';
  code: CreateGroupErrorCode;
  message: Scalars['String'];
};

export enum EditGroupErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  /**
   * This code is returned if it is impossible to modify this group
   * as doing so would leave the organisation with 0 groups able
   * to modify groups.
   * Caused by revoking write_group permission on the last group with that permission.
   */
  LastAdminGroup = 'LAST_ADMIN_GROUP'
}

export type TEditGroupInput = {
  group: Scalars['ID'];
  name?: InputMaybe<Scalars['ConstrainedString__min_1__trim']>;
  organisationPermissions?: InputMaybe<Array<OrganisationPermission>>;
};

export type TEditGroupPayload = {
  __typename: 'EditGroupPayload';
  error?: Maybe<TCreateGroupError>;
  node?: Maybe<TGroup>;
};

export type TEditOrganisationError = {
  __typename: 'EditOrganisationError';
  code: EditOrganisationErrorCode;
  message: Scalars['String'];
};

export enum EditOrganisationErrorCode {
  /** User must have permission write_settings on this organisation */
  AccessDenied = 'ACCESS_DENIED'
}

export type TEditOrganisationInput = {
  name?: InputMaybe<Scalars['ConstrainedString__min_1__trim']>;
  organisation: Scalars['ID'];
};

export type TEditOrganisationPayload = {
  __typename: 'EditOrganisationPayload';
  error?: Maybe<TEditOrganisationError>;
  node?: Maybe<TOrganisation>;
};

export type TExercise = TNode & {
  __typename: 'Exercise';
  author: TUser;
  bodyParts: Array<Scalars['String']>;
  categories: Array<ExerciseCategory>;
  exerciseType: ExerciseSubcategory;
  /** @deprecated use subcategories */
  exerciseTypes: Array<ExerciseSubcategory>;
  id: Scalars['ID'];
  /**
   * Returns the localization that best fits the requested locale.
   * Could return a different locale if the one requested did not match.
   *
   * Set locale to "*" to load all locales.
   * Set to "best-fit" to match Accept-Language & viewer's language preference
   */
  localizations: Array<TExerciseLocalization>;
  subcategories: Array<ExerciseSubcategory>;
  validUnits: Array<UnitType>;
  visibility: ExerciseVisibility;
};


export type TExerciseLocalizationsArgs = {
  locale: Scalars['String'];
};

export { ExerciseCategory };

export type TExerciseLocalization = {
  __typename: 'ExerciseLocalization';
  description: Scalars['String'];
  icon?: Maybe<TAsset>;
  isoCountry?: Maybe<Scalars['String']>;
  isoLanguage: Scalars['String'];
  /** @deprecated Field no longer supported */
  movementName: Scalars['String'];
  movementNamePlural: Scalars['String'];
  movementNameSingular: Scalars['String'];
  /** title + subtitle */
  name: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
  video?: Maybe<TExerciseVideo>;
};

export { ExerciseSubcategory };

export type TExerciseVideo = TAsset | TPlatformVideo;

export enum ExerciseVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum FeedbackType {
  LackOfTime = 'LACK_OF_TIME',
  MisunderstandExercise = 'MISUNDERSTAND_EXERCISE',
  Other = 'OTHER',
  PainBeforeExercise = 'PAIN_BEFORE_EXERCISE',
  PainDuringExercise = 'PAIN_DURING_EXERCISE',
  TooTired = 'TOO_TIRED'
}

export type TFollowUpNeededAlert = TUserTherapistAlert & {
  __typename: 'FollowUpNeededAlert';
  date: Scalars['String'];
  done: Scalars['Boolean'];
  level: AlertLevel;
  type: UserTherapistAlertType;
};

export enum FrequencyType {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type TGeneratePackCodesError = {
  __typename: 'GeneratePackCodesError';
  code: GeneratePackCodesErrorCode;
  message: Scalars['String'];
};

export enum GeneratePackCodesErrorCode {
  AccessDenied = 'ACCESS_DENIED'
}

export type TGeneratePackCodesInput = {
  folderName: Scalars['ConstrainedString__min_1__trim'];
  maxUseCount: Scalars['ConstrainedInt__min_1__max_1000'];
  pack: Scalars['ID'];
  /**
   * set to true to generate 1 code that can be used {maxUseCount} times.
   * set to false to generate {maxUseCount} codes that can be used one time.
   */
  singleCode: Scalars['Boolean'];
};

export type TGeneratePackCodesPayload = {
  __typename: 'GeneratePackCodesPayload';
  error?: Maybe<TGeneratePackCodesError>;
  node?: Maybe<TActivationCodeFolder>;
};

export type TGenericUserTherapistAlert = TUserTherapistAlert & {
  __typename: 'GenericUserTherapistAlert';
  level: AlertLevel;
  type: UserTherapistAlertType;
};

export type TGroup = TNode & {
  __typename: 'Group';
  id: Scalars['ID'];
  /**
   * How many users are in this group.
   * Visible even if the exact member list is not visible to the viewer.
   */
  memberCount: Scalars['Int'];
  /** only members that the viewer is allowed to view will be returned. */
  members: TUserConnection;
  name: Scalars['String'];
  /** The organisation that created this group. */
  organisation: TOrganisation;
  /** The permissions this group grants to its members. Sorted alphabetically. */
  organisationPermissions: Array<OrganisationPermission>;
};


export type TGroupMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type TGroupConnection = {
  __typename: 'GroupConnection';
  nodes: Array<TGroup>;
  pageInfo: TPageInfo;
};

export type TIChallengeTemplate = {
  amount: Scalars['Int'];
  amountUnit: UnitType;
  author: TUser;
  category: ExerciseCategory;
  exercise: TExercise;
  extraInstructions: Scalars['String'];
  /**
   * The schedule template, which will be used to build the corresponding RRule once the challenge becomes live.
   * Can be null for challenge edition proposals that do not modify the schedule of an existing challenge.
   */
  scheduleTemplate?: Maybe<Array<Scalars['JSONObject']>>;
  serialDay?: Maybe<Scalars['Int']>;
  serialDayIndex?: Maybe<Scalars['Int']>;
  series: Scalars['Int'];
};

export type TInactiveUserAlert = TUserTherapistAlert & {
  __typename: 'InactiveUserAlert';
  inactiveSince: Scalars['String'];
  level: AlertLevel;
  type: UserTherapistAlertType;
};

export type TInactivityAlertConfig = {
  __typename: 'InactivityAlertConfig';
  enabled: Scalars['Boolean'];
  level: AlertLevel;
  threshold: Scalars['Int'];
};

export type TInactivityAlertConfigInput = {
  enabled: Scalars['Boolean'];
  level: AlertLevel;
  threshold: Scalars['ConstrainedInt__min_0'];
};

export enum JoiDirectiveCaseEnum {
  Lower = 'LOWER',
  Upper = 'UPPER'
}

export type TMarkMessageAsReadError = {
  __typename: 'MarkMessageAsReadError';
  code: MarkMessageAsReadErrorCode;
  message: Scalars['String'];
};

export enum MarkMessageAsReadErrorCode {
  MessageNotFound = 'MESSAGE_NOT_FOUND'
}

export type TMarkMessageAsReadInput = {
  message: Scalars['ID'];
};

export type TMarkMessageAsReadPayload = {
  __typename: 'MarkMessageAsReadPayload';
  error?: Maybe<TMarkMessageAsReadError>;
  node?: Maybe<TMessage>;
};

export type TMessage = {
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  sentAt: Scalars['Date'];
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TMessageConnection = {
  __typename: 'MessageConnection';
  edges: Array<TMessageEdge>;
  nodes: Array<TMessage>;
  pageInfo: TPageInfo;
  totalCount: Scalars['Int'];
};

export type TMessageEdge = {
  __typename: 'MessageEdge';
  cursor: Scalars['String'];
  node: TMessage;
};

export enum MessageType {
  ChallengeEditProposal = 'CHALLENGE_EDIT_PROPOSAL',
  ChallengeEditProposalResponse = 'CHALLENGE_EDIT_PROPOSAL_RESPONSE',
  ChallengeProposal = 'CHALLENGE_PROPOSAL',
  ChallengeProposalResponse = 'CHALLENGE_PROPOSAL_RESPONSE',
  CoachingProposal = 'COACHING_PROPOSAL',
  CoachingProposalResponse = 'COACHING_PROPOSAL_RESPONSE',
  PackShare = 'PACK_SHARE',
  QuestionProposal = 'QUESTION_PROPOSAL',
  QuestionProposalResponse = 'QUESTION_PROPOSAL_RESPONSE',
  SerialPackProposal = 'SERIAL_PACK_PROPOSAL',
  Text = 'TEXT',
  TherapistApplicationApproved = 'THERAPIST_APPLICATION_APPROVED'
}

export type TMutation = {
  __typename: 'Mutation';
  addChallenge: TAddChallengePayload;
  addChallengeTemplateToPack: TAddChallengeTemplateToPackPayload;
  addMemberToGroup: TAddMemberToGroupPayload;
  answerAddQuestionsProposal: TAnswerAddQuestionsProposalPayload;
  answerQuestion: TAnswerQuestionPayload;
  answerQuestions: TAnswerQuestionsPayload;
  /** You will find therapistAlertConfig on the User type */
  configurePatientAlerts: TConfigurePatientAlertsPayload;
  copyChallengeTemplatePack: TCopyChallengeTemplatePackPayload;
  createAddChallengeProposal: TCreateAddChallengeProposalPayload;
  createChallengeTemplatePack: TCreateChallengeTemplatePackPayload;
  createEditChallengeProposal: TCreateEditChallengeProposalPayload;
  createGroup: TCreateGroupPayload;
  /** This Mutation is restricted to MyMedicoach Administrators. */
  createOrganisation: TCreateOrganisationPayload;
  createUserProvider: TCreateUserProviderPayload;
  deleteGroup: TDeleteGroupPayload;
  /** This Mutation is restricted to MyMedicoach Administrators. */
  deleteOrganisation: TDeleteOrganisationPayload;
  editChallenge: TEditChallengePayload;
  editChallengeTemplate: TEditChallengeTemplatePayload;
  editChallengeTemplatePack: TEditChallengeTemplatePackPayload;
  editGroup: TEditGroupPayload;
  editOrganisation: TEditOrganisationPayload;
  generatePackCodes: TGeneratePackCodesPayload;
  /** Idempotency: This mutation is idempotent. */
  markMessageAsRead: TMarkMessageAsReadPayload;
  proposeAddQuestions: TProposeAddQuestionsPayload;
  removeChallengeTemplateFromPack: TRemoveChallengeTemplateFromPackPayload;
  removeMemberFromGroup: TRemoverMemberFromGroupPayload;
  respondToChallengePackShare: TRespondToChallengePackSharePayload;
  respondToChallengeProposals: TRespondToChallengeProposalsPayload;
  respondToSerialPackProposal: TRespondToSerialPackProposalPayload;
  sendChallengePack: TSendChallengePackPayload;
  /**
   * Send a message to another user.
   *
   * Idempotency: The mutation will be ignored if another message already exists with the following equal properties:
   * - input.idempotencyKey
   * - input.content
   * - viewer (the sender)
   */
  sendMessage: TSendMessagePayload;
  sendSerialPackProposal: TSendSerialPackProposalPayload;
  /** trigger an alert when the response to this question is less than or equal to $value */
  setQuestionAlerts: TSetQuestionAlertsPayload;
  shareChallengePackWithTherapist: TShareChallengePackWithTherapistPayload;
  toggleChallengePackArchived: TToggleChallengePackArchivedPayload;
  toggleCodeRevoked: TToggleCodeRevokedPayload;
  toggleDisplayPainIndicator: TToggleDisplayPainIndicatorPayload;
  updateAddChallengeProposal: TUpdateAddChallengeProposalPayload;
  updateEditChallengeProposal: TUpdateEditChallengeProposalPayload;
  /** This operation is idempotent */
  usePackCode: TUsePackCodePayload;
};


export type TMutationAddChallengeArgs = {
  input: TAddChallengeInput;
};


export type TMutationAddChallengeTemplateToPackArgs = {
  input: TAddChallengeTemplateToPackInput;
};


export type TMutationAddMemberToGroupArgs = {
  input: TAddMemberToGroupInput;
};


export type TMutationAnswerAddQuestionsProposalArgs = {
  input: TAnswerAddQuestionsProposalInput;
};


export type TMutationAnswerQuestionArgs = {
  input: TAnswerQuestionInput;
};


export type TMutationAnswerQuestionsArgs = {
  input: Array<TAnswerQuestionInput>;
};


export type TMutationConfigurePatientAlertsArgs = {
  input?: InputMaybe<TTherapistAlertConfigInput>;
};


export type TMutationCopyChallengeTemplatePackArgs = {
  input: TCopyChallengeTemplatePackInput;
};


export type TMutationCreateAddChallengeProposalArgs = {
  input: TCreateAddChallengeProposalInput;
};


export type TMutationCreateChallengeTemplatePackArgs = {
  input: TCreateChallengeTemplatePackInput;
};


export type TMutationCreateEditChallengeProposalArgs = {
  input: TCreateEditChallengeProposalInput;
};


export type TMutationCreateGroupArgs = {
  input: TCreateGroupInput;
};


export type TMutationCreateOrganisationArgs = {
  input: TCreateOrganisationInput;
};


export type TMutationCreateUserProviderArgs = {
  input: TCreateUserProviderInput;
};


export type TMutationDeleteGroupArgs = {
  input: TDeleteGroupInput;
};


export type TMutationDeleteOrganisationArgs = {
  input: TDeleteOrganisationInput;
};


export type TMutationEditChallengeArgs = {
  input: TEditChallengeInput;
};


export type TMutationEditChallengeTemplateArgs = {
  input: TEditChallengeTemplateInput;
};


export type TMutationEditChallengeTemplatePackArgs = {
  input: TEditChallengeTemplatePackInput;
};


export type TMutationEditGroupArgs = {
  input: TEditGroupInput;
};


export type TMutationEditOrganisationArgs = {
  input: TEditOrganisationInput;
};


export type TMutationGeneratePackCodesArgs = {
  input: TGeneratePackCodesInput;
};


export type TMutationMarkMessageAsReadArgs = {
  input: TMarkMessageAsReadInput;
};


export type TMutationProposeAddQuestionsArgs = {
  input: TProposeAddQuestionsInput;
};


export type TMutationRemoveChallengeTemplateFromPackArgs = {
  input: TRemoveChallengeTemplateFromPackInput;
};


export type TMutationRemoveMemberFromGroupArgs = {
  input: TRemoveMemberFromGroupInput;
};


export type TMutationRespondToChallengePackShareArgs = {
  input: TRespondToChallengePackShareInput;
};


export type TMutationRespondToChallengeProposalsArgs = {
  input: TRespondToChallengeProposalsInput;
};


export type TMutationRespondToSerialPackProposalArgs = {
  input: TRespondToSerialPackProposalInput;
};


export type TMutationSendChallengePackArgs = {
  input: TSendChallengePackInput;
};


export type TMutationSendMessageArgs = {
  input: TSendMessageInput;
};


export type TMutationSendSerialPackProposalArgs = {
  input: TSendSerialPackProposalInput;
};


export type TMutationSetQuestionAlertsArgs = {
  input: TSetQuestionAlertsInput;
};


export type TMutationShareChallengePackWithTherapistArgs = {
  input: TShareChallengePackWithTherapistInput;
};


export type TMutationToggleChallengePackArchivedArgs = {
  input: TToggleChallengePackArchivedInput;
};


export type TMutationToggleCodeRevokedArgs = {
  input: TToggleCodeRevokedInput;
};


export type TMutationToggleDisplayPainIndicatorArgs = {
  input: TToggleDisplayPainIndicatorInput;
};


export type TMutationUpdateAddChallengeProposalArgs = {
  input: TUpdateAddChallengeProposalInput;
};


export type TMutationUpdateEditChallengeProposalArgs = {
  input: TUpdateEditChallengeProposalInput;
};


export type TMutationUsePackCodeArgs = {
  input: TUsePackCodeInput;
};

export type TNode = {
  id: Scalars['ID'];
};

export type TOrganisation = TNode & {
  __typename: 'Organisation';
  /** only groups that the viewer is allowed to view will be returned. */
  groups: TGroupConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The permissions of the viewer regarding this organisation. Sorted alphabetically. */
  viewerPermissions: Array<OrganisationPermission>;
};


export type TOrganisationGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type TOrganisationConnection = {
  __typename: 'OrganisationConnection';
  nodes: Array<TOrganisation>;
  pageInfo: TPageInfo;
};

export enum OrganisationPermission {
  ReadGroups = 'read_groups',
  WriteGroups = 'write_groups',
  WriteSettings = 'write_settings'
}

export type TPackShareMessage = TMessage & TNode & {
  __typename: 'PackShareMessage';
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  pack?: Maybe<TChallengeTemplatePack>;
  packChallenges: Array<TChallengeTemplate>;
  sentAt: Scalars['Date'];
  share: TChallengePackShare;
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TPageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TPagination = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TPlatformVideo = {
  __typename: 'PlatformVideo';
  platform: VideoPlatform;
  videoId: Scalars['String'];
};

export type TProposeAddQuestionsError = {
  __typename: 'ProposeAddQuestionsError';
  code: ProposeAddQuestionsErrorCode;
  message: Scalars['String'];
};

export enum ProposeAddQuestionsErrorCode {
  EmptyQuestionList = 'EMPTY_QUESTION_LIST',
  ErrEndDateTooFar = 'ERR_END_DATE_TOO_FAR',
  ErrNoOccurrences = 'ERR_NO_OCCURRENCES',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  InvalidRruleSyntax = 'INVALID_RRULE_SYNTAX',
  PatientNotFound = 'PATIENT_NOT_FOUND',
  QuestionNotFound = 'QUESTION_NOT_FOUND',
  ViewerNotTherapist = 'VIEWER_NOT_THERAPIST'
}

export type TProposeAddQuestionsInput = {
  patient: Scalars['ID'];
  questions: Array<TQuestionWithAlertInput>;
  rrule: Scalars['String'];
};

export type TProposeAddQuestionsPayload = {
  __typename: 'ProposeAddQuestionsPayload';
  error?: Maybe<TProposeAddQuestionsError>;
  node?: Maybe<TAddQuestionProposal>;
};

export type TQuery = {
  __typename: 'Query';
  /**
   * Returns the list of questions that have been assigned to a given user.
   * Filters:
   *  - patientId: Limits the questions to those assigned to the user matching this ID
   *     Defaults to the Viewer if unspecified / null.
   *     You still need to be allowed to view those entries.
   *  - authorId: Limits the questions to those assigned by the user matching this ID.
   *  - activeAt: Limits the questions to those that are active within a given ISO 8601 DateOnly range
   *     Active means that the date is within the question's [startDate, endDate] range
   *     Example values:
   *     - "2020-01-01/2020-01-07": Returns all questions that are active between 2020-01-01 & 2020-01-07 (inclusive)
   *     - "2020-01-01": Equivalent to "2020-01-01/2020-01-01"
   *  - plannedOn: Limits the questions to those that have at least one day planned on the specified day.
   *     ISO 8601 DateOnly
   */
  assignedQuestions: Array<TQuestion>;
  /**
   * finds a challenge by its ID.
   * returns null if the challenge does not exist, or if the viewer cannot see it.
   */
  challenge?: Maybe<TChallenge>;
  /** Share of a copied pack, if any (recipient banner / attribution). */
  challengePackShare?: Maybe<TChallengePackShare>;
  /** Shares the viewer sent for a source pack (therapists this pack was shared with). */
  challengePackShares: Array<TChallengePackShare>;
  challengeTemplate?: Maybe<TChallengeTemplate>;
  challengeTemplatePack?: Maybe<TChallengeTemplatePack>;
  challengeTemplatePacks: Array<TChallengeTemplatePack>;
  /**
   * Returns all challenges that are assigned to the viewer (or to patientId)
   * - activeAt filters the challenges to only return those that are still active within a given ISO 8601 DateOnly range.
   *   Example values:
   *   - "2020-01-01/2020-01-07": Returns all challenges that are active between 2020-01-01 & 2020-01-07 (inclusive)
   *   - "2020-01-01": Equivalent to "2020-01-01/2020-01-01"
   *   - "2020-01-01/*": Means active at or after 2020-01-01
   * - inactiveAt filters the challenges to only return those that are inactive at a given date (range not supported)
   * - authorId filters to only return challenges created by the user matching the ID
   * - patientId filters to only return challenges assigned to the user matching the ID
   * - first adds a limit to how many items should be returned
   */
  challenges: Array<TChallenge>;
  contacts: TUserConnection;
  conversations: TConversationConnection;
  exercise?: Maybe<TExercise>;
  group?: Maybe<TGroup>;
  groups: TGroupConnection;
  /** Returns the message that matches the specified ID if the viewer is allowed to view it. */
  message?: Maybe<TMessage>;
  messages: TMessageConnection;
  node?: Maybe<TNode>;
  organisation?: Maybe<TOrganisation>;
  /** lists all organisations visible by the viewer */
  organisations: TOrganisationConnection;
  packCodeFolder?: Maybe<TActivationCodeFolder>;
  packCodeFolders: TActivationCodeFolderConnection;
  patientByUserProvider?: Maybe<TUser>;
  question?: Maybe<TQuestion>;
  questions?: Maybe<TQuestionConnection>;
  serialPackProposals: Array<TSerialPackProposal>;
  therapistPatientAlerts: Array<TTherapistPatientAlerts>;
  /**
   * returns all patients planned for the given date, or for any date after the specified date
   * if date is not provided, it defaults to "today" in the therapist's timezone
   */
  therapistPatientPlanning: Array<TTherapistPatientPlanningEntry>;
  therapists: TUserConnection;
  usedExerciseSubcategories: Array<ExerciseSubcategory>;
  user?: Maybe<TUser>;
  userProviderForTherapist?: Maybe<TUserProvider>;
};


export type TQueryAssignedQuestionsArgs = {
  activeAt?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  plannedOn?: InputMaybe<Scalars['String']>;
};


export type TQueryChallengeArgs = {
  id: Scalars['ID'];
};


export type TQueryChallengePackShareArgs = {
  pack: Scalars['ID'];
};


export type TQueryChallengePackSharesArgs = {
  pack: Scalars['ID'];
};


export type TQueryChallengeTemplateArgs = {
  id: Scalars['ID'];
};


export type TQueryChallengeTemplatePackArgs = {
  id: Scalars['ID'];
};


export type TQueryChallengeTemplatePacksArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};


export type TQueryChallengesArgs = {
  activeAt?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inactiveAt?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};


export type TQueryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type TQueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TQueryExerciseArgs = {
  id: Scalars['ID'];
};


export type TQueryGroupArgs = {
  id: Scalars['ID'];
};


export type TQueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  organisation: Scalars['ID'];
};


export type TQueryMessageArgs = {
  id: Scalars['ID'];
};


export type TQueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  around?: InputMaybe<Scalars['String']>;
  aroundLimit?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  conversation?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TQueryNodeArgs = {
  id: Scalars['ID'];
};


export type TQueryOrganisationArgs = {
  id: Scalars['ID'];
};


export type TQueryOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  onlyIfMembership?: InputMaybe<Scalars['Boolean']>;
};


export type TQueryPackCodeFolderArgs = {
  folder: Scalars['ID'];
};


export type TQueryPackCodeFoldersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  pack: Scalars['ID'];
};


export type TQueryPatientByUserProviderArgs = {
  patientProviderUserId: Scalars['String'];
  providerName: Scalars['String'];
  providerUserId: Scalars['String'];
};


export type TQueryQuestionArgs = {
  id: Scalars['ID'];
};


export type TQueryQuestionsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TQuerySerialPackProposalsArgs = {
  packId: Scalars['ID'];
};


export type TQueryTherapistPatientPlanningArgs = {
  date?: InputMaybe<Scalars['String']>;
  withFuture?: InputMaybe<Scalars['Boolean']>;
};


export type TQueryTherapistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};


export type TQueryUserArgs = {
  id: Scalars['ID'];
};


export type TQueryUserProviderForTherapistArgs = {
  providerName: Scalars['String'];
  providerUserId: Scalars['String'];
};

export type TQuestion = TNode & {
  __typename: 'Question';
  id: Scalars['ID'];
  /**
   * Returns the localization that best fits the requested locale.
   * Could return a different locale if the one requested did not match.
   *
   * Set locale to "*" to load all locales.
   * Set to "best-fit" to match Accept-Language & viewer's language preference
   */
  localizations: Array<TQuestionLocalization>;
  responses: Array<TQuestionResponse>;
  /** therapist only: returns the alert a therapist has set on this question for a given patient */
  therapistAlerts: Array<TQuestionAlert>;
};


export type TQuestionLocalizationsArgs = {
  locale: Scalars['String'];
};


export type TQuestionResponsesArgs = {
  dates: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
};


export type TQuestionTherapistAlertsArgs = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type TQuestionAlert = {
  __typename: 'QuestionAlert';
  level: AlertLevel;
  /** triggers an alert when value is less than or equal to */
  value: Scalars['Int'];
};

export type TQuestionAlertInput = {
  level: AlertLevel;
  value: Scalars['Int'];
};

export type TQuestionAnswerAlert = TUserTherapistAlert & {
  __typename: 'QuestionAnswerAlert';
  answer: Scalars['Int'];
  level: AlertLevel;
  question: TQuestion;
  type: UserTherapistAlertType;
};

export type TQuestionConnection = {
  __typename: 'QuestionConnection';
  nodes: Array<TQuestion>;
  pageInfo: TPageInfo;
};

export type TQuestionLocalization = {
  __typename: 'QuestionLocalization';
  description: Scalars['String'];
  locale: Scalars['String'];
  title: Scalars['String'];
};

export type TQuestionProposalMessage = TMessage & TNode & {
  __typename: 'QuestionProposalMessage';
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  questionProposal: TAddQuestionProposal;
  sentAt: Scalars['Date'];
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TQuestionResponse = {
  __typename: 'QuestionResponse';
  /** ISO-8601 DateOnly */
  date: Scalars['String'];
  question: TQuestion;
  value: Scalars['Int'];
};

export type TQuestionWithAlertInput = {
  alerts?: InputMaybe<Array<TQuestionAlertInput>>;
  question: Scalars['ID'];
};

export type TRemoveChallengeTemplateFromPackError = {
  __typename: 'RemoveChallengeTemplateFromPackError';
  code: RemoveChallengeTemplateFromPackErrorCode;
  message: Scalars['String'];
};

export enum RemoveChallengeTemplateFromPackErrorCode {
  ChallengeTemplateNotFound = 'CHALLENGE_TEMPLATE_NOT_FOUND',
  PackNotFound = 'PACK_NOT_FOUND'
}

export type TRemoveChallengeTemplateFromPackInput = {
  challengeTemplate: Scalars['ID'];
  pack: Scalars['ID'];
};

export type TRemoveChallengeTemplateFromPackPayload = {
  __typename: 'RemoveChallengeTemplateFromPackPayload';
  error?: Maybe<TRemoveChallengeTemplateFromPackError>;
  node?: Maybe<TChallengeTemplatePack>;
};

export type TRemoveMemberFromGroupInput = {
  group: Scalars['ID'];
  user: Scalars['ID'];
};

export type TRemoverMemberFromGroupError = {
  __typename: 'RemoverMemberFromGroupError';
  code: RemoverMemberFromGroupErrorCode;
  message: Scalars['String'];
};

export enum RemoverMemberFromGroupErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type TRemoverMemberFromGroupPayload = {
  __typename: 'RemoverMemberFromGroupPayload';
  error?: Maybe<TRemoverMemberFromGroupError>;
  node?: Maybe<TGroup>;
};

export type TRespondToChallengePackShareError = {
  __typename: 'RespondToChallengePackShareError';
  code: RespondToChallengePackShareErrorCode;
  message: Scalars['String'];
};

export enum RespondToChallengePackShareErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  AlreadyResponded = 'ALREADY_RESPONDED',
  ShareNotFound = 'SHARE_NOT_FOUND'
}

export type TRespondToChallengePackShareInput = {
  approval: ApprovalResponse;
  share: Scalars['ID'];
};

export type TRespondToChallengePackSharePayload = {
  __typename: 'RespondToChallengePackSharePayload';
  error?: Maybe<TRespondToChallengePackShareError>;
  node?: Maybe<TChallengePackShare>;
};

export type TRespondToChallengeProposalsError = {
  __typename: 'RespondToChallengeProposalsError';
  code: RespondToChallengeProposalsErrorCode;
  message: Scalars['String'];
};

export enum RespondToChallengeProposalsErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ProposalNotFound = 'PROPOSAL_NOT_FOUND'
}

export type TRespondToChallengeProposalsInput = {
  approval: ApprovalResponse;
  proposals: Array<Scalars['ID']>;
};

export type TRespondToChallengeProposalsPayload = {
  __typename: 'RespondToChallengeProposalsPayload';
  error?: Maybe<TRespondToChallengeProposalsError>;
  node?: Maybe<Array<TChallengeProposal>>;
};

export enum RespondToSerialPackProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ProposalNotFound = 'PROPOSAL_NOT_FOUND'
}

export type TRespondToSerialPackProposalInput = {
  approval: ApprovalResponse;
  proposal: Scalars['ID'];
};

export type TRespondToSerialPackProposalPayload = {
  __typename: 'RespondToSerialPackProposalPayload';
  error?: Maybe<RespondToSerialPackProposalErrorCode>;
  node: TSerialPackProposal;
};

export enum Revoked {
  All = 'All',
  None = 'None',
  Some = 'Some'
}

export type TSendChallengePackError = {
  __typename: 'SendChallengePackError';
  code: SendChallengePackErrorCode;
  message: Scalars['String'];
};

export enum SendChallengePackErrorCode {
  PackNotFound = 'PACK_NOT_FOUND',
  PatientNotFound = 'PATIENT_NOT_FOUND',
  AccessDenied = 'ACCESS_DENIED'
}

export type TSendChallengePackInput = {
  pack: Scalars['ID'];
  patients: Array<Scalars['String']>;
};

export type TSendChallengePackPayload = {
  __typename: 'SendChallengePackPayload';
  error?: Maybe<TSendChallengePackError>;
  node?: Maybe<Array<TChallengeProposal>>;
};

export type TSendMessageError = {
  __typename: 'SendMessageError';
  code: SendMessageErrorCode;
  message: Scalars['String'];
};

export enum SendMessageErrorCode {
  ConversationNotFound = 'CONVERSATION_NOT_FOUND'
}

export type TSendMessageInput = {
  /**
   * The ID or Slug of the user that should receive this message.
   * Mutually exclusive with conversation
   */
  contact?: InputMaybe<Scalars['String']>;
  content: Scalars['ConstrainedString__min_1__trim'];
  /**
   * The ID or Slug of the conversation to which the message should be send.
   * Mutually exclusive with contact
   */
  conversation?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['ConstrainedString__uuidV4']>;
};

export type TSendMessagePayload = {
  __typename: 'SendMessagePayload';
  error?: Maybe<TSendMessageError>;
  node?: Maybe<TMessage>;
};

export type TSendSerialPackProposalError = {
  __typename: 'SendSerialPackProposalError';
  code: SendSerialPackProposalErrorCode;
  message: Scalars['String'];
};

export enum SendSerialPackProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  PackNotFound = 'PACK_NOT_FOUND',
  PatientNotFound = 'PATIENT_NOT_FOUND'
}

export type TSendSerialPackProposalInput = {
  pack: Scalars['ID'];
  patients: Array<Scalars['ID']>;
};

export type TSendSerialPackProposalPayload = {
  __typename: 'SendSerialPackProposalPayload';
  error?: Maybe<TSendSerialPackProposalError>;
  node?: Maybe<Array<TSerialPackProposal>>;
};

export type TSerialPackProposal = TNode & {
  __typename: 'SerialPackProposal';
  approval?: Maybe<Approval>;
  id: Scalars['ID'];
  pack?: Maybe<TChallengeTemplatePack>;
};

export type TSerialPackProposalMessage = TMessage & TNode & {
  __typename: 'SerialPackProposalMessage';
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  pack: TChallengeTemplatePack;
  packChallenges: Array<TChallengeTemplate>;
  proposal: TSerialPackProposal;
  sentAt: Scalars['Date'];
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TSetQuestionAlertsError = {
  __typename: 'SetQuestionAlertsError';
  code: SetQuestionAlertsErrorCode;
  message: Scalars['String'];
};

export enum SetQuestionAlertsErrorCode {
  PatientNotFound = 'PATIENT_NOT_FOUND',
  QuestionNotAssigned = 'QUESTION_NOT_ASSIGNED',
  ViewerNotTherapist = 'VIEWER_NOT_THERAPIST'
}

export type TSetQuestionAlertsInput = {
  alerts: Array<TQuestionAlertInput>;
  patient: Scalars['String'];
  question: Scalars['ID'];
};

export type TSetQuestionAlertsPayload = {
  __typename: 'SetQuestionAlertsPayload';
  error?: Maybe<TSetQuestionAlertsError>;
  node?: Maybe<Array<TQuestionAlert>>;
};

export type TShareChallengePackWithTherapistError = {
  __typename: 'ShareChallengePackWithTherapistError';
  code: ShareChallengePackWithTherapistErrorCode;
  message: Scalars['String'];
};

export enum ShareChallengePackWithTherapistErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  AlreadyPending = 'ALREADY_PENDING',
  CannotShareWithSelf = 'CANNOT_SHARE_WITH_SELF',
  PackEmpty = 'PACK_EMPTY',
  PackNotFound = 'PACK_NOT_FOUND',
  TherapistNotFound = 'THERAPIST_NOT_FOUND'
}

export type TShareChallengePackWithTherapistInput = {
  pack: Scalars['ID'];
  therapist: Scalars['String'];
};

export type TShareChallengePackWithTherapistPayload = {
  __typename: 'ShareChallengePackWithTherapistPayload';
  error?: Maybe<TShareChallengePackWithTherapistError>;
  node?: Maybe<TChallengePackShare>;
};

export type TSubscription = {
  __typename: 'Subscription';
  /**
   * Used to notify when either:
   * - a new message has been sent to one of the viewer's conversations by someone else than the viewer.
   * - a message has been modified.
   * - an element the message depends on has been modified (eg. a ChallengeProposal in a ChallengeProposalMessage has been accepted).
   * Optionally filterable with a conversation ID
   */
  changedMessages: Array<TMessage>;
};


export type TSubscriptionChangedMessagesArgs = {
  conversation?: InputMaybe<Scalars['ID']>;
};

export type TTextMessage = TMessage & TNode & {
  __typename: 'TextMessage';
  author: TUser;
  content: Scalars['String'];
  conversation: TConversation;
  id: Scalars['ID'];
  messageType: MessageType;
  sentAt: Scalars['Date'];
  /** null if not read by viewer */
  viewerReadAt?: Maybe<Scalars['Date']>;
};

export type TTherapistAlertConfig = {
  __typename: 'TherapistAlertConfig';
  inactivity: TInactivityAlertConfig;
};

export type TTherapistAlertConfigInput = {
  inactivity?: InputMaybe<TInactivityAlertConfigInput>;
  patient: Scalars['ID'];
};

export type TTherapistPatientAlerts = {
  __typename: 'TherapistPatientAlerts';
  alerts: Array<TUserTherapistAlert>;
  patient: TUser;
};

export type TTherapistPatientPlanningEntry = {
  __typename: 'TherapistPatientPlanningEntry';
  date: Scalars['String'];
  patient: TUser;
};

export type TToggleChallengePackArchivedError = {
  __typename: 'ToggleChallengePackArchivedError';
  code: ToggleChallengePackArchivedErrorCode;
  message: Scalars['String'];
};

export enum ToggleChallengePackArchivedErrorCode {
  PackNotFound = 'PACK_NOT_FOUND'
}

export type TToggleChallengePackArchivedInput = {
  archived: Scalars['Boolean'];
  pack: Scalars['ID'];
};

export type TToggleChallengePackArchivedPayload = {
  __typename: 'ToggleChallengePackArchivedPayload';
  error?: Maybe<TToggleChallengePackArchivedError>;
  node?: Maybe<TChallengeTemplatePack>;
};

export type TToggleCodeRevokedError = {
  __typename: 'ToggleCodeRevokedError';
  code: ToggleCodeRevokedErrorCode;
  message: Scalars['String'];
};

export enum ToggleCodeRevokedErrorCode {
  AccessDenied = 'ACCESS_DENIED'
}

export type TToggleCodeRevokedInput = {
  codeOrFolder: Scalars['ID'];
  revoked: Scalars['Boolean'];
};

export type TToggleCodeRevokedPayload = {
  __typename: 'ToggleCodeRevokedPayload';
  error?: Maybe<TToggleCodeRevokedError>;
  node?: Maybe<TCodeOrFolder>;
};

export type TToggleDisplayPainIndicatorError = {
  __typename: 'ToggleDisplayPainIndicatorError';
  code: ToggleDisplayPainIndicatorErrorCode;
  message: Scalars['String'];
};

export enum ToggleDisplayPainIndicatorErrorCode {
  ViewerNotTherapist = 'VIEWER_NOT_THERAPIST'
}

export type TToggleDisplayPainIndicatorInput = {
  enabled: Scalars['Boolean'];
};

export type TToggleDisplayPainIndicatorPayload = {
  __typename: 'ToggleDisplayPainIndicatorPayload';
  error?: Maybe<TToggleDisplayPainIndicatorError>;
  node?: Maybe<TUser>;
};

export { UnitType };

export type TUpdateAddChallengeProposalError = {
  __typename: 'UpdateAddChallengeProposalError';
  code: UpdateAddChallengeProposalErrorCode;
  message: Scalars['String'];
};

export enum UpdateAddChallengeProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ErrNoOccurrences = 'ERR_NO_OCCURRENCES',
  ErrTooManyOccurrences = 'ERR_TOO_MANY_OCCURRENCES',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND'
}

export type TUpdateAddChallengeProposalInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountUnit?: InputMaybe<UnitType>;
  category?: InputMaybe<ExerciseCategory>;
  exercise?: InputMaybe<Scalars['ID']>;
  extraInstructions?: InputMaybe<Scalars['String']>;
  proposalId: Scalars['ID'];
  /** JSON-serialised TScheduleTemplate objects */
  scheduleTemplate?: InputMaybe<Array<Scalars['JSONObject']>>;
  series?: InputMaybe<Scalars['Int']>;
};

export type TUpdateAddChallengeProposalPayload = {
  __typename: 'UpdateAddChallengeProposalPayload';
  error?: Maybe<TUpdateAddChallengeProposalError>;
  node: TChallengeProposal;
};

export type TUpdateEditChallengeProposalError = {
  __typename: 'UpdateEditChallengeProposalError';
  code: UpdateEditChallengeProposalErrorCode;
  message: Scalars['String'];
};

export enum UpdateEditChallengeProposalErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  ErrExerciseCategoryMismatch = 'ERR_EXERCISE_CATEGORY_MISMATCH',
  ErrExerciseUnitMismatch = 'ERR_EXERCISE_UNIT_MISMATCH',
  ExerciseNotFound = 'EXERCISE_NOT_FOUND'
}

export type TUpdateEditChallengeProposalInput = {
  amount?: InputMaybe<Scalars['Int']>;
  exercise?: InputMaybe<Scalars['ID']>;
  extraInstructions?: InputMaybe<Scalars['String']>;
  proposalId: Scalars['ID'];
  /**
   * JSON-serialised TScheduleTemplate objects
   * can be null if no changes should be applied once the patient accepts the proposal
   */
  scheduleTemplate?: InputMaybe<Array<Scalars['JSONObject']>>;
  series?: InputMaybe<Scalars['Int']>;
};

export type TUpdateEditChallengeProposalPayload = {
  __typename: 'UpdateEditChallengeProposalPayload';
  error?: Maybe<TUpdateEditChallengeProposalError>;
  node: TChallengeProposal;
};

export type TUsePackCodeError = {
  __typename: 'UsePackCodeError';
  code: UsePackCodeErrorErrorCode;
  message: Scalars['String'];
};

export enum UsePackCodeErrorErrorCode {
  InvalidCode = 'INVALID_CODE'
}

export type TUsePackCodeInput = {
  code: Scalars['String'];
};

export type TUsePackCodePayload = {
  __typename: 'UsePackCodePayload';
  error?: Maybe<TUsePackCodeError>;
};

export type TUser = TNode & {
  __typename: 'User';
  avatar: Scalars['String'];
  birthday?: Maybe<Scalars['Date']>;
  displayPainIndicator?: Maybe<Scalars['Boolean']>;
  /** Private data, null if the viewer is not allowed to view it */
  email?: Maybe<Scalars['String']>;
  /** if a user has not joined yet, this may be replaced by another value to identify them */
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isoCountry?: Maybe<Scalars['String']>;
  isoLanguage?: Maybe<Scalars['String']>;
  /** False if the user was invited but has not joined MyMedicoach yet */
  joined: Scalars['Boolean'];
  joinedOn?: Maybe<Scalars['Date']>;
  /** may be empty but never null */
  lastName: Scalars['String'];
  locales: Array<Scalars['String']>;
  roles: Array<Scalars['String']>;
  slug: Scalars['String'];
  stripeConnectPubKey?: Maybe<Scalars['String']>;
  stripeConnected?: Maybe<Scalars['Boolean']>;
  /** null if the viewer is not a therapist */
  therapistAlertConfig?: Maybe<TTherapistAlertConfig>;
  timeZone?: Maybe<Scalars['String']>;
  /** One-to-one conversation between viewer & this user, if one exists */
  viewerConversation?: Maybe<TConversation>;
};

export type TUserConnection = {
  __typename: 'UserConnection';
  nodes: Array<TUser>;
  pageInfo: TPageInfo;
  totalCount: Scalars['Int'];
};

export type TUserProvider = TNode & {
  __typename: 'UserProvider';
  id: Scalars['ID'];
  providerName: Scalars['String'];
  providerUserId: Scalars['String'];
  providerUserType: Scalars['String'];
};

export type TUserProviderError = {
  __typename: 'UserProviderError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type TUserTherapistAlert = {
  level: AlertLevel;
  type: UserTherapistAlertType;
};

/** unreadPainFeedback */
export enum UserTherapistAlertType {
  FollowUpNeeded = 'FollowUpNeeded',
  Inactive = 'Inactive',
  /**
   * UnreadMessage
   * UnreadFeedback
   * UnreadPainFeedback
   */
  QuestionAnswer = 'QuestionAnswer'
}

export enum VideoPlatform {
  Vimeo = 'vimeo',
  Youtube = 'youtube'
}

export type TExerciseSubcategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TExerciseSubcategoriesQuery = { __typename: 'Query', usedExerciseSubcategories: Array<ExerciseSubcategory> };

export type TRespondToChallengeProposalMutationVariables = Exact<{
  input: TRespondToChallengeProposalsInput;
}>;


export type TRespondToChallengeProposalMutation = { __typename: 'Mutation', respondToChallengeProposals: { __typename: 'RespondToChallengeProposalsPayload', error?: { __typename: 'RespondToChallengeProposalsError', code: RespondToChallengeProposalsErrorCode } | null, node?: Array<{ __typename: 'ChallengeProposal', id: string, approval: Approval, createdChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null }> } | null }> | null } };

export type TRespondToSerialPackProposalMutationVariables = Exact<{
  input: TRespondToSerialPackProposalInput;
}>;


export type TRespondToSerialPackProposalMutation = { __typename: 'Mutation', respondToSerialPackProposal: { __typename: 'RespondToSerialPackProposalPayload', error?: RespondToSerialPackProposalErrorCode | null, node: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } };

export type TCreateOrganisationMutationVariables = Exact<{
  input: TCreateOrganisationInput;
}>;


export type TCreateOrganisationMutation = { __typename: 'Mutation', createOrganisation: { __typename: 'CreateOrganisationPayload', error?: { __typename: 'CreateOrganisationError', code: CreateOrganisationErrorCode } | null, node?: { __typename: 'Organisation', id: string, name: string } | null } };

export type TEditOrganisationMutationVariables = Exact<{
  input: TEditOrganisationInput;
}>;


export type TEditOrganisationMutation = { __typename: 'Mutation', editOrganisation: { __typename: 'EditOrganisationPayload', error?: { __typename: 'EditOrganisationError', code: EditOrganisationErrorCode } | null, node?: { __typename: 'Organisation', id: string, name: string } | null } };

export type TDeleteOrganisationMutationVariables = Exact<{
  input: TDeleteOrganisationInput;
}>;


export type TDeleteOrganisationMutation = { __typename: 'Mutation', deleteOrganisation: { __typename: 'DeleteOrganisationPayload', error?: { __typename: 'DeleteOrganisationError', code: EditOrganisationErrorCode } | null } };

export type TCreateGroupMutationVariables = Exact<{
  input: TCreateGroupInput;
}>;


export type TCreateGroupMutation = { __typename: 'Mutation', createGroup: { __typename: 'CreateGroupPayload', error?: { __typename: 'CreateGroupError', code: CreateGroupErrorCode } | null, node?: { __typename: 'Group', id: string, name: string, memberCount: number } | null } };

export type TEditGroupMutationVariables = Exact<{
  input: TEditGroupInput;
}>;


export type TEditGroupMutation = { __typename: 'Mutation', editGroup: { __typename: 'EditGroupPayload', error?: { __typename: 'CreateGroupError', code: CreateGroupErrorCode } | null, node?: { __typename: 'Group', id: string, name: string, organisationPermissions: Array<OrganisationPermission>, organisation: { __typename: 'Organisation', id: string, viewerPermissions: Array<OrganisationPermission> } } | null } };

export type TDeleteGroupMutationVariables = Exact<{
  input: TDeleteGroupInput;
}>;


export type TDeleteGroupMutation = { __typename: 'Mutation', deleteGroup: { __typename: 'DeleteGroupPayload', error?: { __typename: 'DeleteGroupError', code: DeleteGroupErrorCode } | null } };

export type TAddMemberToGroupMutationVariables = Exact<{
  input: TAddMemberToGroupInput;
}>;


export type TAddMemberToGroupMutation = { __typename: 'Mutation', addMemberToGroup: { __typename: 'AddMemberToGroupPayload', error?: { __typename: 'AddMemberToGroupError', code: AddMemberToGroupErrorCode } | null, node?: { __typename: 'Group', id: string, memberCount: number, organisation: { __typename: 'Organisation', id: string, viewerPermissions: Array<OrganisationPermission> } } | null } };

export type TRemoveMemberFromGroupMutationVariables = Exact<{
  input: TRemoveMemberFromGroupInput;
}>;


export type TRemoveMemberFromGroupMutation = { __typename: 'Mutation', removeMemberFromGroup: { __typename: 'RemoverMemberFromGroupPayload', error?: { __typename: 'RemoverMemberFromGroupError', code: RemoverMemberFromGroupErrorCode } | null, node?: { __typename: 'Group', id: string, memberCount: number, organisation: { __typename: 'Organisation', id: string, viewerPermissions: Array<OrganisationPermission> } } | null } };

export type TGeneratePackCodesMutationVariables = Exact<{
  input: TGeneratePackCodesInput;
}>;


export type TGeneratePackCodesMutation = { __typename: 'Mutation', generatePackCodes: { __typename: 'GeneratePackCodesPayload', node?: { __typename: 'ActivationCodeFolder', id: string } | null, error?: { __typename: 'GeneratePackCodesError', code: GeneratePackCodesErrorCode } | null } };

export type TToggleCodeRevokedMutationVariables = Exact<{
  input: TToggleCodeRevokedInput;
}>;


export type TToggleCodeRevokedMutation = { __typename: 'Mutation', toggleCodeRevoked: { __typename: 'ToggleCodeRevokedPayload', error?: { __typename: 'ToggleCodeRevokedError', code: ToggleCodeRevokedErrorCode } | null, node?: { __typename: 'ActivationCode', id: string, revoked: boolean } | { __typename: 'ActivationCodeFolder', id: string, codesRevoked: Revoked } | null } };

export type TEditChallengePackMutationVariables = Exact<{
  input: TEditChallengeTemplatePackInput;
}>;


export type TEditChallengePackMutation = { __typename: 'Mutation', editChallengeTemplatePack: { __typename: 'EditChallengeTemplatePackPayload', error?: { __typename: 'EditChallengeTemplatePackError', code: EditChallengeTemplatePackErrorCode } | null, node?: { __typename: 'ChallengeTemplatePack', id: string, description: string, name: string } | null } };

export type TRemoveChallengeFromPackMutationVariables = Exact<{
  input: TRemoveChallengeTemplateFromPackInput;
}>;


export type TRemoveChallengeFromPackMutation = { __typename: 'Mutation', removeChallengeTemplateFromPack: { __typename: 'RemoveChallengeTemplateFromPackPayload', error?: { __typename: 'RemoveChallengeTemplateFromPackError', code: RemoveChallengeTemplateFromPackErrorCode } | null, node?: { __typename: 'ChallengeTemplatePack', id: string, description: string, name: string } | null } };

export type TAddChallengeTemplateToPackMutationVariables = Exact<{
  input: TAddChallengeTemplateToPackInput;
}>;


export type TAddChallengeTemplateToPackMutation = { __typename: 'Mutation', addChallengeTemplateToPack: { __typename: 'AddChallengeTemplateToPackPayload', error?: { __typename: 'AddChallengeTemplateToPackError', code: AddChallengeTemplateToPackErrorCode } | null, node?: { __typename: 'ChallengeTemplate', id: string } | null } };

export type TUpdateChallengeTemplateMutationVariables = Exact<{
  input: TEditChallengeTemplateInput;
}>;


export type TUpdateChallengeTemplateMutation = { __typename: 'Mutation', editChallengeTemplate: { __typename: 'EditChallengeTemplatePayload', error?: { __typename: 'EditChallengeTemplateError', code: EditChallengeTemplateErrorCode } | null, node?: { __typename: 'ChallengeTemplate', id: string } | null } };

export type TAddChallengeMutationVariables = Exact<{
  input: TAddChallengeInput;
}>;


export type TAddChallengeMutation = { __typename: 'Mutation', addChallenge: { __typename: 'AddChallengePayload', error?: { __typename: 'AddChallengeError', code: AddChallengeErrorCode } | null, node?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null }> } | null } };

export type TEditChallengeMutationVariables = Exact<{
  input: TEditChallengeInput;
}>;


export type TEditChallengeMutation = { __typename: 'Mutation', editChallenge: { __typename: 'EditChallengePayload', error?: { __typename: 'EditChallengeError', code: EditChallengeErrorCode } | null, node?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null }> } | null } };

export type TCreateAddChallengeProposalMutationVariables = Exact<{
  input: TCreateAddChallengeProposalInput;
}>;


export type TCreateAddChallengeProposalMutation = { __typename: 'Mutation', createAddChallengeProposal: { __typename: 'CreateAddChallengeProposalPayload', error?: { __typename: 'CreateAddChallengeProposalError', code: CreateAddChallengeProposalErrorCode } | null, node?: Array<{ __typename: 'ChallengeProposal', id: string, patient: { __typename: 'User', id: string, slug: string } }> | null } };

export type TUpdateAddChallengeProposalMutationVariables = Exact<{
  input: TUpdateAddChallengeProposalInput;
}>;


export type TUpdateAddChallengeProposalMutation = { __typename: 'Mutation', updateAddChallengeProposal: { __typename: 'UpdateAddChallengeProposalPayload', error?: { __typename: 'UpdateAddChallengeProposalError', code: UpdateAddChallengeProposalErrorCode } | null, node: { __typename: 'ChallengeProposal', id: string } } };

export type TArchivePackMutationVariables = Exact<{
  input: TToggleChallengePackArchivedInput;
}>;


export type TArchivePackMutation = { __typename: 'Mutation', toggleChallengePackArchived: { __typename: 'ToggleChallengePackArchivedPayload', error?: { __typename: 'ToggleChallengePackArchivedError', code: ToggleChallengePackArchivedErrorCode } | null, node?: { __typename: 'ChallengeTemplatePack', id: string, archived: boolean } | null } };

export type TCreateChallengePackMutationVariables = Exact<{
  input: TCreateChallengeTemplatePackInput;
}>;


export type TCreateChallengePackMutation = { __typename: 'Mutation', createChallengeTemplatePack: { __typename: 'CreateChallengeTemplatePackPayload', error?: { __typename: 'CreateChallengeTemplatePackError', code: CreateChallengeTemplatePackErrorCode } | null, node?: { __typename: 'ChallengeTemplatePack', id: string } | null } };

export type TSendChallengePackMutationVariables = Exact<{
  input: TSendChallengePackInput;
}>;


export type TSendChallengePackMutation = { __typename: 'Mutation', sendChallengePack: { __typename: 'SendChallengePackPayload', error?: { __typename: 'SendChallengePackError', code: SendChallengePackErrorCode } | null, node?: Array<{ __typename: 'ChallengeProposal', id: string, patient: { __typename: 'User', id: string, slug: string } }> | null } };

export type TSendSerialPackProposalMutationVariables = Exact<{
  input: TSendSerialPackProposalInput;
}>;


export type TSendSerialPackProposalMutation = { __typename: 'Mutation', sendSerialPackProposal: { __typename: 'SendSerialPackProposalPayload', error?: { __typename: 'SendSerialPackProposalError', code: SendSerialPackProposalErrorCode } | null, node?: Array<{ __typename: 'SerialPackProposal', id: string }> | null } };

export type TUsePackCodeMutationVariables = Exact<{
  input: TUsePackCodeInput;
}>;


export type TUsePackCodeMutation = { __typename: 'Mutation', usePackCode: { __typename: 'UsePackCodePayload', error?: { __typename: 'UsePackCodeError', code: UsePackCodeErrorErrorCode } | null } };

export type TCopyChallengePackMutationVariables = Exact<{
  input: TCopyChallengeTemplatePackInput;
}>;


export type TCopyChallengePackMutation = { __typename: 'Mutation', copyChallengeTemplatePack: { __typename: 'CopyChallengeTemplatePackPayload', error?: { __typename: 'CopyChallengeTemplatePackError', code: CopyChallengeTemplatePackErrorCode } | null, node?: { __typename: 'ChallengeTemplatePack', id: string } | null } };

export type TShareChallengePackWithTherapistMutationVariables = Exact<{
  input: TShareChallengePackWithTherapistInput;
}>;


export type TShareChallengePackWithTherapistMutation = { __typename: 'Mutation', shareChallengePackWithTherapist: { __typename: 'ShareChallengePackWithTherapistPayload', error?: { __typename: 'ShareChallengePackWithTherapistError', code: ShareChallengePackWithTherapistErrorCode, message: string } | null, node?: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null } | null } };

export type TRespondToChallengePackShareMutationVariables = Exact<{
  input: TRespondToChallengePackShareInput;
}>;


export type TRespondToChallengePackShareMutation = { __typename: 'Mutation', respondToChallengePackShare: { __typename: 'RespondToChallengePackSharePayload', error?: { __typename: 'RespondToChallengePackShareError', code: RespondToChallengePackShareErrorCode, message: string } | null, node?: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null } | null } };

export type TSendMessageMutationVariables = Exact<{
  input: TSendMessageInput;
}>;


export type TSendMessageMutation = { __typename: 'Mutation', sendMessage: { __typename: 'SendMessagePayload', error?: { __typename: 'SendMessageError', code: SendMessageErrorCode } | null, node?: { __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } } | null } };

export type TMarkMessageAsReadMutationVariables = Exact<{
  input: TMarkMessageAsReadInput;
}>;


export type TMarkMessageAsReadMutation = { __typename: 'Mutation', markMessageAsRead: { __typename: 'MarkMessageAsReadPayload', error?: { __typename: 'MarkMessageAsReadError', code: MarkMessageAsReadErrorCode } | null, node?: { __typename: 'ChallengeProposalMessage', id: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } } | { __typename: 'CoachingProposalMessage', id: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } } | { __typename: 'PackShareMessage', id: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } } | { __typename: 'QuestionProposalMessage', id: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } } | { __typename: 'SerialPackProposalMessage', id: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } } | { __typename: 'TextMessage', id: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } } | null } };

export type TUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TUserQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } | null };

export type TViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type TViewerQuery = { __typename: 'Query', user?: { __typename: 'User', email?: string | null, birthday?: string | null, isoCountry?: string | null, timeZone?: string | null, stripeConnected?: boolean | null, stripeConnectPubKey?: string | null, id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } | null };

export type TUserFragment = { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null };

export type TViewerFragment = { __typename: 'User', email?: string | null, birthday?: string | null, isoCountry?: string | null, timeZone?: string | null, stripeConnected?: boolean | null, stripeConnectPubKey?: string | null, id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null };

export type TMessageChangeSubscriptionVariables = Exact<{
  conversation?: InputMaybe<Scalars['ID']>;
}>;


export type TMessageChangeSubscription = { __typename: 'Subscription', changedMessages: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, conversation: { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }, author: { __typename: 'User', id: string } }> };

export type TCalendarExerciseFragmentFragment = { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string }> };

type TCalendarFragment_ActivationCode_Fragment = { __typename: 'ActivationCode', id: string };

type TCalendarFragment_ActivationCodeFolder_Fragment = { __typename: 'ActivationCodeFolder', id: string };

type TCalendarFragment_AddQuestionProposal_Fragment = { __typename: 'AddQuestionProposal', rrule: string, id: string };

type TCalendarFragment_Asset_Fragment = { __typename: 'Asset', id: string };

type TCalendarFragment_Challenge_Fragment = { __typename: 'Challenge', category: ExerciseCategory, id: string, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null, endDate?: string | null, versionIndex: number, historicalRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> };

type TCalendarFragment_ChallengePackShare_Fragment = { __typename: 'ChallengePackShare', id: string };

type TCalendarFragment_ChallengeProposal_Fragment = { __typename: 'ChallengeProposal', startDate: string, endDate?: string | null, rrule: string, category: ExerciseCategory, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, approval: Approval, id: string, editedChallenge?: { __typename: 'Challenge', id: string } | null, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } };

type TCalendarFragment_ChallengeProposalMessage_Fragment = { __typename: 'ChallengeProposalMessage', id: string };

type TCalendarFragment_ChallengeTemplate_Fragment = { __typename: 'ChallengeTemplate', scheduleTemplate: Array<object>, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, id: string, exercise: { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string }> } };

type TCalendarFragment_ChallengeTemplatePack_Fragment = { __typename: 'ChallengeTemplatePack', id: string };

type TCalendarFragment_CoachingProposalMessage_Fragment = { __typename: 'CoachingProposalMessage', id: string };

type TCalendarFragment_CoachingSubscription_Fragment = { __typename: 'CoachingSubscription', id: string };

type TCalendarFragment_Conversation_Fragment = { __typename: 'Conversation', id: string };

type TCalendarFragment_Exercise_Fragment = { __typename: 'Exercise', id: string };

type TCalendarFragment_Group_Fragment = { __typename: 'Group', id: string };

type TCalendarFragment_Organisation_Fragment = { __typename: 'Organisation', id: string };

type TCalendarFragment_PackShareMessage_Fragment = { __typename: 'PackShareMessage', id: string };

type TCalendarFragment_Question_Fragment = { __typename: 'Question', id: string };

type TCalendarFragment_QuestionProposalMessage_Fragment = { __typename: 'QuestionProposalMessage', id: string };

type TCalendarFragment_SerialPackProposal_Fragment = { __typename: 'SerialPackProposal', id: string };

type TCalendarFragment_SerialPackProposalMessage_Fragment = { __typename: 'SerialPackProposalMessage', id: string };

type TCalendarFragment_TextMessage_Fragment = { __typename: 'TextMessage', id: string };

type TCalendarFragment_User_Fragment = { __typename: 'User', id: string };

type TCalendarFragment_UserProvider_Fragment = { __typename: 'UserProvider', id: string };

export type TCalendarFragmentFragment = TCalendarFragment_ActivationCode_Fragment | TCalendarFragment_ActivationCodeFolder_Fragment | TCalendarFragment_AddQuestionProposal_Fragment | TCalendarFragment_Asset_Fragment | TCalendarFragment_Challenge_Fragment | TCalendarFragment_ChallengePackShare_Fragment | TCalendarFragment_ChallengeProposal_Fragment | TCalendarFragment_ChallengeProposalMessage_Fragment | TCalendarFragment_ChallengeTemplate_Fragment | TCalendarFragment_ChallengeTemplatePack_Fragment | TCalendarFragment_CoachingProposalMessage_Fragment | TCalendarFragment_CoachingSubscription_Fragment | TCalendarFragment_Conversation_Fragment | TCalendarFragment_Exercise_Fragment | TCalendarFragment_Group_Fragment | TCalendarFragment_Organisation_Fragment | TCalendarFragment_PackShareMessage_Fragment | TCalendarFragment_Question_Fragment | TCalendarFragment_QuestionProposalMessage_Fragment | TCalendarFragment_SerialPackProposal_Fragment | TCalendarFragment_SerialPackProposalMessage_Fragment | TCalendarFragment_TextMessage_Fragment | TCalendarFragment_User_Fragment | TCalendarFragment_UserProvider_Fragment;

export type TChallengeExerciseFragment = { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> };

export type TChallengeProposalMessageProposalFragment = { __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null };

export type TSerialPackProposalMessageProposalFragment = { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } };

type TMessage_ChallengeProposalMessage_Fragment = { __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> };

type TMessage_CoachingProposalMessage_Fragment = { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } };

type TMessage_PackShareMessage_Fragment = { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } };

type TMessage_QuestionProposalMessage_Fragment = { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } };

type TMessage_SerialPackProposalMessage_Fragment = { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } };

type TMessage_TextMessage_Fragment = { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } };

export type TMessageFragment = TMessage_ChallengeProposalMessage_Fragment | TMessage_CoachingProposalMessage_Fragment | TMessage_PackShareMessage_Fragment | TMessage_QuestionProposalMessage_Fragment | TMessage_SerialPackProposalMessage_Fragment | TMessage_TextMessage_Fragment;

export type TAvatarFragment = { __typename: 'User', firstName: string, lastName: string, id: string, avatar: string };

export type TChallengePackSharesQueryVariables = Exact<{
  pack: Scalars['ID'];
}>;


export type TChallengePackSharesQuery = { __typename: 'Query', challengePackShares: Array<{ __typename: 'ChallengePackShare', id: string, approval?: Approval | null, recipient: { __typename: 'User', id: string, firstName: string, lastName: string } }> };

export type TPatientAlertSettingsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TPatientAlertSettingsQuery = { __typename: 'Query', user?: { __typename: 'User', therapistAlertConfig?: { __typename: 'TherapistAlertConfig', inactivity: { __typename: 'InactivityAlertConfig', enabled: boolean, level: AlertLevel, threshold: number } } | null } | null };

export type TTherapistsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
}>;


export type TTherapistsQuery = { __typename: 'Query', therapists: { __typename: 'UserConnection', nodes: Array<{ __typename: 'User', firstName: string, lastName: string, joined: boolean, avatar: string, id: string }> } };

export type TChallengeTemplateNewExerciseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TChallengeTemplateNewExerciseQuery = { __typename: 'Query', exercise?: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } | null };

export type TCreateChallengeTemplateExerciseFragment = { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> };

export type TEditChallengeFragmentFragment = { __typename: 'Challenge', id: string, category: ExerciseCategory, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } }>, patient: { __typename: 'User', id: string, slug: string } };

export type TEditChallengeDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TEditChallengeDataQuery = { __typename: 'Query', challenge?: { __typename: 'Challenge', id: string, category: ExerciseCategory, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } }>, patient: { __typename: 'User', id: string, slug: string } } | null };

export type TChallengePackNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TChallengePackNameQuery = { __typename: 'Query', challengeTemplatePack?: { __typename: 'ChallengeTemplatePack', id: string, name: string } | null };

type TEditChallengeTemplate_ChallengeProposal_Fragment = { __typename: 'ChallengeProposal', scheduleTemplate?: Array<object> | null, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null, author: { __typename: 'User', id: string }, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } };

type TEditChallengeTemplate_ChallengeTemplate_Fragment = { __typename: 'ChallengeTemplate', scheduleTemplate: Array<object>, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null, author: { __typename: 'User', id: string }, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } };

export type TEditChallengeTemplateFragment = TEditChallengeTemplate_ChallengeProposal_Fragment | TEditChallengeTemplate_ChallengeTemplate_Fragment;

export type TChallengeTemplateOrProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TChallengeTemplateOrProposalQuery = { __typename: 'Query', node?: { __typename: 'ActivationCode', id: string } | { __typename: 'ActivationCodeFolder', id: string } | { __typename: 'AddQuestionProposal', id: string } | { __typename: 'Asset', id: string } | { __typename: 'Challenge', id: string } | { __typename: 'ChallengePackShare', id: string } | { __typename: 'ChallengeProposal', approval: Approval, id: string, scheduleTemplate?: Array<object> | null, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null, editedChallenge?: { __typename: 'Challenge', id: string, category: ExerciseCategory, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } }>, patient: { __typename: 'User', id: string, slug: string } } | null, author: { __typename: 'User', id: string }, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } } | { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'ChallengeTemplate', id: string, scheduleTemplate: Array<object>, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null, author: { __typename: 'User', id: string }, exercise: { __typename: 'Exercise', id: string, validUnits: Array<UnitType>, categories: Array<ExerciseCategory>, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string }> } } | { __typename: 'ChallengeTemplatePack', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'CoachingSubscription', id: string } | { __typename: 'Conversation', id: string } | { __typename: 'Exercise', id: string } | { __typename: 'Group', id: string } | { __typename: 'Organisation', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposal', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | { __typename: 'User', id: string } | { __typename: 'UserProvider', id: string } | null };

export type TActivationCodesViewQueryVariables = Exact<{
  pack: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type TActivationCodesViewQuery = { __typename: 'Query', packCodeFolders: { __typename: 'ActivationCodeFolderConnection', totalCount: number, nodes: Array<{ __typename: 'ActivationCodeFolder', id: string, createdAt: string, name: string, codesRevoked: Revoked, maxUseCount: number, codeUsers: { __typename: 'UserConnection', totalCount: number }, codes: { __typename: 'ActivationCodeConnection', totalCount: number, nodes: Array<{ __typename: 'ActivationCode', id: string, value: string, revoked: boolean }> }, author: { __typename: 'User', firstName: string, lastName: string, id: string, avatar: string } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type TFolderQueryVariables = Exact<{
  id: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type TFolderQuery = { __typename: 'Query', packCodeFolder?: { __typename: 'ActivationCodeFolder', id: string, codes: { __typename: 'ActivationCodeConnection', totalCount: number, nodes: Array<{ __typename: 'ActivationCode', id: string, revoked: boolean, maxUseCount: number, value: string, codeUsers: { __typename: 'UserConnection', totalCount: number } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } } | null };

export type TChallengePackViewQueryVariables = Exact<{
  packId: Scalars['ID'];
}>;


export type TChallengePackViewQuery = { __typename: 'Query', challengeTemplatePack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, archived: boolean, description: string, type: ChallengeTemplatePackTypes, sharePending: boolean, codeFolders: { __typename: 'ActivationCodeFolderConnection', totalCount: number }, challenges: Array<{ __typename: 'ChallengeTemplate', id: string, amount: number, amountUnit: UnitType, category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null, extraInstructions: string, scheduleTemplate: Array<object>, series: number, exercise: { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, name: string, icon?: { __typename: 'Asset', formats: Array<{ __typename: 'AssetFormat', encoding: string, fileName: string, height?: number | null, width?: number | null }> } | null }> } }> } | null };

export type TSerialPackProposalsQueryVariables = Exact<{
  packId: Scalars['ID'];
}>;


export type TSerialPackProposalsQuery = { __typename: 'Query', serialPackProposals: Array<{ __typename: 'SerialPackProposal', id: string, approval?: Approval | null, pack?: { __typename: 'ChallengeTemplatePack', id: string } | null }> };

export type TChallengePackShareQueryVariables = Exact<{
  packId: Scalars['ID'];
}>;


export type TChallengePackShareQuery = { __typename: 'Query', challengePackShare?: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string, firstName: string, lastName: string } } | null };

export type TChallengePacksViewQueryVariables = Exact<{
  archived: Scalars['Boolean'];
  type?: InputMaybe<Scalars['String']>;
}>;


export type TChallengePacksViewQuery = { __typename: 'Query', challengeTemplatePacks: Array<{ __typename: 'ChallengeTemplatePack', id: string, name: string, description: string, archived: boolean, sharePending: boolean, type: ChallengeTemplatePackTypes, challenges: Array<{ __typename: 'ChallengeTemplate', id: string }> }> };

export type TContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type TContactsQuery = { __typename: 'Query', contacts: { __typename: 'UserConnection', nodes: Array<{ __typename: 'User', firstName: string, lastName: string, joined: boolean, avatar: string, id: string }> } };

export type TMessageHistoryQueryVariables = Exact<{
  conversation: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  around?: InputMaybe<Scalars['String']>;
  aroundLimit?: InputMaybe<Scalars['Int']>;
}>;


export type TMessageHistoryQuery = { __typename: 'Query', messages: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }>, pageInfo: { __typename: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type TConversationQueryVariables = Exact<{
  contact: Scalars['ID'];
}>;


export type TConversationQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null, viewerConversation?: { __typename: 'Conversation', id: string, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null } | null } | null };

export type TConversationListQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type TConversationListQuery = { __typename: 'Query', conversations: { __typename: 'ConversationConnection', nodes: Array<{ __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TConversationFragment = { __typename: 'Conversation', id: string, createdAt: string, lastMessage: { __typename: 'MessageConnection', nodes: Array<{ __typename: 'ChallengeProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, challengeProposals: Array<{ __typename: 'ChallengeProposal', id: string, scheduleTemplate?: Array<object> | null, approval: Approval, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, author: { __typename: 'User', id: string }, editedChallenge?: { __typename: 'Challenge', id: string, versions: Array<{ __typename: 'ChallengeVersion', lastRRule: string, series: number, amount: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null }> } | { __typename: 'CoachingProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, coachingProposal: { __typename: 'CoachingSubscription', id: string, patientTotalPrice: number, approval: Approval, duration: number, therapist: { __typename: 'User', id: string }, recurrence: { __typename: 'CoachingSubscriptionRecurrence', frequency: FrequencyType, interval: number } } } | { __typename: 'PackShareMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, sharedPack?: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } } | null, share: { __typename: 'ChallengePackShare', id: string, approval?: Approval | null, packName: string, author: { __typename: 'User', id: string } } } | { __typename: 'QuestionProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, questionProposal: { __typename: 'AddQuestionProposal', id: string, rrule: string, approval: Approval, questions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', title: string }> }>, therapist: { __typename: 'User', id: string }, patient: { __typename: 'User', id: string, slug: string } } } | { __typename: 'SerialPackProposalMessage', id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, pack: { __typename: 'ChallengeTemplatePack', id: string, name: string, author: { __typename: 'User', id: string } }, packChallenges: Array<{ __typename: 'ChallengeTemplate', category: ExerciseCategory, serialDay?: number | null, serialDayIndex?: number | null }>, proposal: { __typename: 'SerialPackProposal', id: string, approval?: Approval | null } } | { __typename: 'TextMessage', content: string, id: string, messageType: MessageType, sentAt: string, viewerReadAt?: string | null, author: { __typename: 'User', id: string } }> }, oldestUnreadMessage?: { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | null, contact: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } };

export type TChallengeViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TChallengeViewQuery = { __typename: 'Query', challenge?: { __typename: 'Challenge', id: string, category: ExerciseCategory, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null, endDate?: string | null, versionIndex: number, historicalRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | null };

export type TChallengeProposalViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TChallengeProposalViewQuery = { __typename: 'Query', node?: { __typename: 'ActivationCode', id: string } | { __typename: 'ActivationCodeFolder', id: string } | { __typename: 'AddQuestionProposal', id: string, rrule: string } | { __typename: 'Asset', id: string } | { __typename: 'Challenge', id: string, category: ExerciseCategory, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null, endDate?: string | null, versionIndex: number, historicalRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | { __typename: 'ChallengePackShare', id: string } | { __typename: 'ChallengeProposal', id: string, startDate: string, endDate?: string | null, rrule: string, category: ExerciseCategory, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, approval: Approval, editedChallenge?: { __typename: 'Challenge', id: string } | null, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } | { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'ChallengeTemplate', id: string, scheduleTemplate: Array<object>, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, exercise: { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string }> } } | { __typename: 'ChallengeTemplatePack', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'CoachingSubscription', id: string } | { __typename: 'Conversation', id: string } | { __typename: 'Exercise', id: string } | { __typename: 'Group', id: string } | { __typename: 'Organisation', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposal', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | { __typename: 'User', id: string } | { __typename: 'UserProvider', id: string } | null };

export type TExerciseLocalizationFragment = { __typename: 'ExerciseLocalization', title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null };

export type TGroupViewQueryVariables = Exact<{
  groupId: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type TGroupViewQuery = { __typename: 'Query', group?: { __typename: 'Group', id: string, name: string, memberCount: number, organisationPermissions: Array<OrganisationPermission>, members: { __typename: 'UserConnection', totalCount: number, nodes: Array<{ __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } }, organisation: { __typename: 'Organisation', id: string, name: string, viewerPermissions: Array<OrganisationPermission> } } | null };

export type TOrganisationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TOrganisationQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: string, name: string, viewerPermissions: Array<OrganisationPermission> } | null };

export type TOrganisationMembersQueryVariables = Exact<{
  orgId: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type TOrganisationMembersQuery = { __typename: 'Query', organisation?: { __typename: 'Organisation', id: string, groups: { __typename: 'GroupConnection', nodes: Array<{ __typename: 'Group', id: string, name: string, memberCount: number }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type TOrganisationsQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  onlyIfMembership?: InputMaybe<Scalars['Boolean']>;
}>;


export type TOrganisationsQuery = { __typename: 'Query', organisations: { __typename: 'OrganisationConnection', nodes: Array<{ __typename: 'Organisation', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type TGetStatDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TGetStatDetailsQuery = { __typename: 'Query', challenge?: { __typename: 'Challenge', id: string, totalDone: number, category: ExerciseCategory, versions: Array<{ __typename: 'ChallengeVersion', versionIndex: number, historicalRRule: string, amount: number, series: number, amountUnit: UnitType, startDate?: string | null, endDate?: string | null, extraInstructions: string, exercise: { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, bodyParts: Array<string>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, name: string, description: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }>, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } | null };

export type TStatCheckInDataQueryVariables = Exact<{
  id: Scalars['ID'];
  dates: Scalars['String'];
}>;


export type TStatCheckInDataQuery = { __typename: 'Query', challenge?: { __typename: 'Challenge', versions: Array<{ __typename: 'ChallengeVersion', historicalRRule: string, amount: number, series: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', localizations: Array<{ __typename: 'ExerciseLocalization', movementNameSingular: string, movementNamePlural: string }> }, checkIns: Array<{ __typename: 'ChallengeCheckIn', dueDate: string, amounts: Array<number>, feedback: string, feedbackPositive?: boolean | null, feedbackTypes: Array<FeedbackType> }> }> } | null };

export type TStatListViewQueryVariables = Exact<{
  userId: Scalars['ID'];
  activeAt?: InputMaybe<Scalars['String']>;
  inactiveAt?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  versionRange: Scalars['String'];
}>;


export type TStatListViewQuery = { __typename: 'Query', pageOwner?: { __typename: 'User', firstName: string, lastName: string, id: string, slug: string } | null, challenges: Array<{ __typename: 'Challenge', id: string, totalDone: number, category: ExerciseCategory, versions: Array<{ __typename: 'ChallengeVersion', versionIndex: number, historicalRRule: string, amount: number, series: number, amountUnit: UnitType, exercise: { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', title: string, subtitle: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, checkIns: Array<{ __typename: 'ChallengeCheckIn', amounts: Array<number>, dueDate: string, feedbackTypes: Array<FeedbackType>, feedbackPositive?: boolean | null, feedback: string }> }> }>, assignedQuestions: Array<{ __typename: 'Question', id: string }> };

export type TPatientCalendarFilteredViewQueryVariables = Exact<{
  entityId: Scalars['ID'];
}>;


export type TPatientCalendarFilteredViewQuery = { __typename: 'Query', node?: { __typename: 'ActivationCode', id: string } | { __typename: 'ActivationCodeFolder', id: string } | { __typename: 'AddQuestionProposal', rrule: string, id: string } | { __typename: 'Asset', id: string } | { __typename: 'Challenge', category: ExerciseCategory, id: string, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null, endDate?: string | null, versionIndex: number, historicalRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> } | { __typename: 'ChallengePackShare', id: string } | { __typename: 'ChallengeProposal', startDate: string, endDate?: string | null, rrule: string, category: ExerciseCategory, series: number, amount: number, amountUnit: UnitType, extraInstructions: string, approval: Approval, id: string, editedChallenge?: { __typename: 'Challenge', id: string } | null, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> }, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null } } | { __typename: 'ChallengeProposalMessage', id: string } | { __typename: 'ChallengeTemplate', scheduleTemplate: Array<object>, extraInstructions: string, category: ExerciseCategory, serialDay?: number | null, id: string, exercise: { __typename: 'Exercise', id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string }> } } | { __typename: 'ChallengeTemplatePack', id: string } | { __typename: 'CoachingProposalMessage', id: string } | { __typename: 'CoachingSubscription', id: string } | { __typename: 'Conversation', id: string } | { __typename: 'Exercise', id: string } | { __typename: 'Group', id: string } | { __typename: 'Organisation', id: string } | { __typename: 'PackShareMessage', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionProposalMessage', id: string } | { __typename: 'SerialPackProposal', id: string } | { __typename: 'SerialPackProposalMessage', id: string } | { __typename: 'TextMessage', id: string } | { __typename: 'User', id: string } | { __typename: 'UserProvider', id: string } | null };

export type TPatientCalendarViewQueryVariables = Exact<{
  activeAt: Scalars['String'];
}>;


export type TPatientCalendarViewQuery = { __typename: 'Query', challenges: Array<{ __typename: 'Challenge', category: ExerciseCategory, id: string, patient: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, author: { __typename: 'User', id: string, slug: string, avatar: string, firstName: string, lastName: string, joined: boolean, locales: Array<string>, roles: Array<string>, isoLanguage?: string | null }, versions: Array<{ __typename: 'ChallengeVersion', startDate?: string | null, endDate?: string | null, versionIndex: number, historicalRRule: string, amount: number, amountUnit: UnitType, series: number, extraInstructions: string, exercise: { __typename: 'Exercise', bodyParts: Array<string>, id: string, exerciseTypes: Array<ExerciseSubcategory>, localizations: Array<{ __typename: 'ExerciseLocalization', name: string, title: string, subtitle: string, description: string, movementNameSingular: string, movementNamePlural: string, isoLanguage: string, icon?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | null, video?: { __typename: 'Asset', id: string, formats: Array<{ __typename: 'AssetFormat', fileName: string, encoding: string, height?: number | null, width?: number | null }> } | { __typename: 'PlatformVideo', videoId: string, platform: VideoPlatform } | null }> } }> }>, assignedQuestions: Array<{ __typename: 'Question', id: string }> };

export type TPatientPlanningQueryVariables = Exact<{
  date: Scalars['String'];
}>;


export type TPatientPlanningQuery = { __typename: 'Query', challenges: Array<{ __typename: 'Challenge', id: string }>, assignedQuestions: Array<{ __typename: 'Question', id: string, localizations: Array<{ __typename: 'QuestionLocalization', locale: string, title: string, description: string }>, responses: Array<{ __typename: 'QuestionResponse', value: number, date: string }> }> };

export type TTherapistDashboardAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type TTherapistDashboardAlertsQuery = { __typename: 'Query', therapistPatientAlerts: Array<{ __typename: 'TherapistPatientAlerts', patient: { __typename: 'User', id: string, slug: string, firstName: string, lastName: string, roles: Array<string>, avatar: string }, alerts: Array<{ __typename: 'FollowUpNeededAlert', done: boolean, date: string, type: UserTherapistAlertType, level: AlertLevel } | { __typename: 'GenericUserTherapistAlert', type: UserTherapistAlertType, level: AlertLevel } | { __typename: 'InactiveUserAlert', type: UserTherapistAlertType, level: AlertLevel } | { __typename: 'QuestionAnswerAlert', type: UserTherapistAlertType, level: AlertLevel, question: { __typename: 'Question', id: string } }> }> };

type TTherapistDashboardAlert_FollowUpNeededAlert_Fragment = { __typename: 'FollowUpNeededAlert', done: boolean, date: string, type: UserTherapistAlertType, level: AlertLevel };

type TTherapistDashboardAlert_GenericUserTherapistAlert_Fragment = { __typename: 'GenericUserTherapistAlert', type: UserTherapistAlertType, level: AlertLevel };

type TTherapistDashboardAlert_InactiveUserAlert_Fragment = { __typename: 'InactiveUserAlert', type: UserTherapistAlertType, level: AlertLevel };

type TTherapistDashboardAlert_QuestionAnswerAlert_Fragment = { __typename: 'QuestionAnswerAlert', type: UserTherapistAlertType, level: AlertLevel, question: { __typename: 'Question', id: string } };

export type TTherapistDashboardAlertFragment = TTherapistDashboardAlert_FollowUpNeededAlert_Fragment | TTherapistDashboardAlert_GenericUserTherapistAlert_Fragment | TTherapistDashboardAlert_InactiveUserAlert_Fragment | TTherapistDashboardAlert_QuestionAnswerAlert_Fragment;

export type TTherapistDashboardPlanningQueryVariables = Exact<{ [key: string]: never; }>;


export type TTherapistDashboardPlanningQuery = { __typename: 'Query', therapistPatientPlanning: Array<{ __typename: 'TherapistPatientPlanningEntry', date: string, patient: { __typename: 'User', id: string, slug: string, firstName: string, lastName: string, roles: Array<string>, avatar: string } }> };

export const UserFragmentDoc = /*#__PURE__*/ gql`
    fragment User on User {
  id
  slug
  avatar
  firstName
  lastName
  joined
  locales
  roles
  isoLanguage
}
    `;
export const ViewerFragmentDoc = /*#__PURE__*/ gql`
    fragment Viewer on User {
  ...User
  email
  birthday
  isoCountry
  timeZone
  stripeConnected
  stripeConnectPubKey
}
    ${UserFragmentDoc}`;
export const ExerciseLocalizationFragmentDoc = /*#__PURE__*/ gql`
    fragment ExerciseLocalization on ExerciseLocalization {
  title
  subtitle
  description
  movementNameSingular
  movementNamePlural
  isoLanguage
  icon {
    id
    formats {
      fileName
      encoding
      height
      width
    }
  }
  video {
    ... on Asset {
      id
      formats {
        fileName
        encoding
        height
        width
      }
    }
    ... on PlatformVideo {
      videoId
      platform
    }
  }
}
    `;
export const ChallengeExerciseFragmentDoc = /*#__PURE__*/ gql`
    fragment ChallengeExercise on Exercise {
  id
  localizations(locale: "best-fit") {
    ...ExerciseLocalization
  }
}
    ${ExerciseLocalizationFragmentDoc}`;
export const CalendarExerciseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment calendarExerciseFragment on Exercise {
  id
  exerciseTypes
  localizations(locale: "best-fit") {
    name
  }
}
    `;
export const CalendarFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment calendarFragment on Node {
  id
  __typename
  ... on AddQuestionProposal {
    rrule
  }
  ... on Challenge {
    category
    patient {
      ...User
    }
    author {
      ...User
    }
    versions {
      startDate
      endDate
      versionIndex
      historicalRRule
      amount
      amountUnit
      series
      extraInstructions
      exercise {
        bodyParts
        ...ChallengeExercise
        ...calendarExerciseFragment
      }
    }
  }
  ... on ChallengeProposal {
    startDate
    endDate
    rrule
    category
    series
    amount
    amountUnit
    extraInstructions
    editedChallenge {
      id
    }
    approval
    exercise {
      bodyParts
      ...ChallengeExercise
      ...calendarExerciseFragment
    }
    patient {
      ...User
    }
    author {
      ...User
    }
  }
  ... on ChallengeTemplate {
    scheduleTemplate
    extraInstructions
    category
    serialDay
    exercise {
      ...calendarExerciseFragment
    }
  }
}
    ${UserFragmentDoc}
${ChallengeExerciseFragmentDoc}
${CalendarExerciseFragmentFragmentDoc}`;
export const AvatarFragmentDoc = /*#__PURE__*/ gql`
    fragment Avatar on User {
  firstName
  lastName
  id
  avatar
}
    `;
export const CreateChallengeTemplateExerciseFragmentDoc = /*#__PURE__*/ gql`
    fragment CreateChallengeTemplateExercise on Exercise {
  id
  validUnits
  categories
  localizations(locale: "best-fit") {
    title
    subtitle
    movementNameSingular
    movementNamePlural
  }
  ...calendarExerciseFragment
}
    ${CalendarExerciseFragmentFragmentDoc}`;
export const EditChallengeFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment editChallengeFragment on Challenge {
  id
  category
  versions {
    lastRRule
    amount
    amountUnit
    series
    exercise {
      ...CreateChallengeTemplateExercise
    }
    extraInstructions
  }
  patient {
    id
    slug
  }
}
    ${CreateChallengeTemplateExerciseFragmentDoc}`;
export const EditChallengeTemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment editChallengeTemplate on IChallengeTemplate {
  scheduleTemplate
  series
  amount
  amountUnit
  extraInstructions
  category
  serialDay
  serialDayIndex
  author {
    id
  }
  exercise {
    ...CreateChallengeTemplateExercise
  }
}
    ${CreateChallengeTemplateExerciseFragmentDoc}`;
export const ChallengeProposalMessageProposalFragmentDoc = /*#__PURE__*/ gql`
    fragment ChallengeProposalMessageProposal on ChallengeProposal {
  id
  scheduleTemplate
  approval
  series
  amount
  amountUnit
  exercise {
    ...ChallengeExercise
  }
  author {
    id
  }
  editedChallenge {
    id
    versions {
      lastRRule
      series
      amount
      amountUnit
      exercise {
        ...ChallengeExercise
      }
    }
  }
}
    ${ChallengeExerciseFragmentDoc}`;
export const SerialPackProposalMessageProposalFragmentDoc = /*#__PURE__*/ gql`
    fragment SerialPackProposalMessageProposal on ChallengeTemplatePack {
  id
  name
  author {
    id
  }
}
    `;
export const MessageFragmentDoc = /*#__PURE__*/ gql`
    fragment Message on Message {
  __typename
  id
  messageType
  sentAt
  viewerReadAt
  ... on TextMessage {
    content
    author {
      id
    }
  }
  ... on ChallengeProposalMessage {
    challengeProposals {
      ...ChallengeProposalMessageProposal
    }
  }
  ... on SerialPackProposalMessage {
    pack {
      ...SerialPackProposalMessageProposal
    }
    packChallenges {
      category
      serialDay
      serialDayIndex
    }
    proposal {
      id
      approval
    }
  }
  ... on PackShareMessage {
    sharedPack: pack {
      id
      name
      author {
        id
      }
    }
    share {
      id
      approval
      packName
      author {
        id
      }
    }
  }
  ... on CoachingProposalMessage {
    coachingProposal {
      id
      patientTotalPrice
      therapist {
        id
      }
      approval
      duration
      recurrence {
        frequency
        interval
      }
    }
  }
  ... on QuestionProposalMessage {
    questionProposal {
      id
      rrule
      approval
      questions {
        id
        localizations(locale: "best-fit") {
          title
        }
      }
      therapist {
        id
      }
      patient {
        id
        slug
      }
    }
  }
}
    ${ChallengeProposalMessageProposalFragmentDoc}
${SerialPackProposalMessageProposalFragmentDoc}`;
export const ConversationFragmentDoc = /*#__PURE__*/ gql`
    fragment Conversation on Conversation {
  id
  createdAt
  lastMessage: messages(first: 1) {
    nodes {
      ...Message
    }
  }
  oldestUnreadMessage {
    id
  }
  contact {
    ...User
  }
}
    ${MessageFragmentDoc}
${UserFragmentDoc}`;
export const TherapistDashboardAlertFragmentDoc = /*#__PURE__*/ gql`
    fragment TherapistDashboardAlert on UserTherapistAlert {
  __typename
  type
  level
  ... on FollowUpNeededAlert {
    done
    date
  }
  ... on QuestionAnswerAlert {
    question {
      id
    }
  }
}
    `;
export const ExerciseSubcategoriesDocument = /*#__PURE__*/ gql`
    query exerciseSubcategories {
  usedExerciseSubcategories
}
    `;

export function useExerciseSubcategoriesQuery(options?: Omit<Urql.UseQueryArgs<TExerciseSubcategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<TExerciseSubcategoriesQuery, TExerciseSubcategoriesQueryVariables>({ query: ExerciseSubcategoriesDocument, ...options });
};
export const RespondToChallengeProposalDocument = /*#__PURE__*/ gql`
    mutation respondToChallengeProposal($input: RespondToChallengeProposalsInput!) {
  respondToChallengeProposals(input: $input) {
    error {
      code
    }
    node {
      id
      approval
      createdChallenge {
        id
        versions {
          startDate
        }
      }
    }
  }
}
    `;

export function useRespondToChallengeProposalMutation() {
  return Urql.useMutation<TRespondToChallengeProposalMutation, TRespondToChallengeProposalMutationVariables>(RespondToChallengeProposalDocument);
};
export const RespondToSerialPackProposalDocument = /*#__PURE__*/ gql`
    mutation respondToSerialPackProposal($input: RespondToSerialPackProposalInput!) {
  respondToSerialPackProposal(input: $input) {
    error
    node {
      id
      approval
    }
  }
}
    `;

export function useRespondToSerialPackProposalMutation() {
  return Urql.useMutation<TRespondToSerialPackProposalMutation, TRespondToSerialPackProposalMutationVariables>(RespondToSerialPackProposalDocument);
};
export const CreateOrganisationDocument = /*#__PURE__*/ gql`
    mutation createOrganisation($input: CreateOrganisationInput!) {
  createOrganisation(input: $input) {
    error {
      code
    }
    node {
      id
      name
    }
  }
}
    `;

export function useCreateOrganisationMutation() {
  return Urql.useMutation<TCreateOrganisationMutation, TCreateOrganisationMutationVariables>(CreateOrganisationDocument);
};
export const EditOrganisationDocument = /*#__PURE__*/ gql`
    mutation editOrganisation($input: EditOrganisationInput!) {
  editOrganisation(input: $input) {
    error {
      code
    }
    node {
      id
      name
    }
  }
}
    `;

export function useEditOrganisationMutation() {
  return Urql.useMutation<TEditOrganisationMutation, TEditOrganisationMutationVariables>(EditOrganisationDocument);
};
export const DeleteOrganisationDocument = /*#__PURE__*/ gql`
    mutation deleteOrganisation($input: DeleteOrganisationInput!) {
  deleteOrganisation(input: $input) {
    error {
      code
    }
  }
}
    `;

export function useDeleteOrganisationMutation() {
  return Urql.useMutation<TDeleteOrganisationMutation, TDeleteOrganisationMutationVariables>(DeleteOrganisationDocument);
};
export const CreateGroupDocument = /*#__PURE__*/ gql`
    mutation createGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    error {
      code
    }
    node {
      id
      name
      memberCount
    }
  }
}
    `;

export function useCreateGroupMutation() {
  return Urql.useMutation<TCreateGroupMutation, TCreateGroupMutationVariables>(CreateGroupDocument);
};
export const EditGroupDocument = /*#__PURE__*/ gql`
    mutation editGroup($input: EditGroupInput!) {
  editGroup(input: $input) {
    error {
      code
    }
    node {
      id
      name
      organisationPermissions
      organisation {
        id
        viewerPermissions
      }
    }
  }
}
    `;

export function useEditGroupMutation() {
  return Urql.useMutation<TEditGroupMutation, TEditGroupMutationVariables>(EditGroupDocument);
};
export const DeleteGroupDocument = /*#__PURE__*/ gql`
    mutation deleteGroup($input: DeleteGroupInput!) {
  deleteGroup(input: $input) {
    error {
      code
    }
  }
}
    `;

export function useDeleteGroupMutation() {
  return Urql.useMutation<TDeleteGroupMutation, TDeleteGroupMutationVariables>(DeleteGroupDocument);
};
export const AddMemberToGroupDocument = /*#__PURE__*/ gql`
    mutation addMemberToGroup($input: AddMemberToGroupInput!) {
  addMemberToGroup(input: $input) {
    error {
      code
    }
    node {
      id
      memberCount
      organisation {
        id
        viewerPermissions
      }
    }
  }
}
    `;

export function useAddMemberToGroupMutation() {
  return Urql.useMutation<TAddMemberToGroupMutation, TAddMemberToGroupMutationVariables>(AddMemberToGroupDocument);
};
export const RemoveMemberFromGroupDocument = /*#__PURE__*/ gql`
    mutation removeMemberFromGroup($input: RemoveMemberFromGroupInput!) {
  removeMemberFromGroup(input: $input) {
    error {
      code
    }
    node {
      id
      memberCount
      organisation {
        id
        viewerPermissions
      }
    }
  }
}
    `;

export function useRemoveMemberFromGroupMutation() {
  return Urql.useMutation<TRemoveMemberFromGroupMutation, TRemoveMemberFromGroupMutationVariables>(RemoveMemberFromGroupDocument);
};
export const GeneratePackCodesDocument = /*#__PURE__*/ gql`
    mutation generatePackCodes($input: GeneratePackCodesInput!) {
  generatePackCodes(input: $input) {
    node {
      id
    }
    error {
      code
    }
  }
}
    `;

export function useGeneratePackCodesMutation() {
  return Urql.useMutation<TGeneratePackCodesMutation, TGeneratePackCodesMutationVariables>(GeneratePackCodesDocument);
};
export const ToggleCodeRevokedDocument = /*#__PURE__*/ gql`
    mutation toggleCodeRevoked($input: ToggleCodeRevokedInput!) {
  toggleCodeRevoked(input: $input) {
    error {
      code
    }
    node {
      ... on ActivationCode {
        id
        revoked
      }
      ... on ActivationCodeFolder {
        id
        codesRevoked
      }
    }
  }
}
    `;

export function useToggleCodeRevokedMutation() {
  return Urql.useMutation<TToggleCodeRevokedMutation, TToggleCodeRevokedMutationVariables>(ToggleCodeRevokedDocument);
};
export const EditChallengePackDocument = /*#__PURE__*/ gql`
    mutation editChallengePack($input: EditChallengeTemplatePackInput!) {
  editChallengeTemplatePack(input: $input) {
    error {
      code
    }
    node {
      id
      description
      name
    }
  }
}
    `;

export function useEditChallengePackMutation() {
  return Urql.useMutation<TEditChallengePackMutation, TEditChallengePackMutationVariables>(EditChallengePackDocument);
};
export const RemoveChallengeFromPackDocument = /*#__PURE__*/ gql`
    mutation removeChallengeFromPack($input: RemoveChallengeTemplateFromPackInput!) {
  removeChallengeTemplateFromPack(input: $input) {
    error {
      code
    }
    node {
      id
      description
      name
    }
  }
}
    `;

export function useRemoveChallengeFromPackMutation() {
  return Urql.useMutation<TRemoveChallengeFromPackMutation, TRemoveChallengeFromPackMutationVariables>(RemoveChallengeFromPackDocument);
};
export const AddChallengeTemplateToPackDocument = /*#__PURE__*/ gql`
    mutation addChallengeTemplateToPack($input: AddChallengeTemplateToPackInput!) {
  addChallengeTemplateToPack(input: $input) {
    error {
      code
    }
    node {
      id
    }
  }
}
    `;

export function useAddChallengeTemplateToPackMutation() {
  return Urql.useMutation<TAddChallengeTemplateToPackMutation, TAddChallengeTemplateToPackMutationVariables>(AddChallengeTemplateToPackDocument);
};
export const UpdateChallengeTemplateDocument = /*#__PURE__*/ gql`
    mutation updateChallengeTemplate($input: EditChallengeTemplateInput!) {
  editChallengeTemplate(input: $input) {
    error {
      code
    }
    node {
      id
    }
  }
}
    `;

export function useUpdateChallengeTemplateMutation() {
  return Urql.useMutation<TUpdateChallengeTemplateMutation, TUpdateChallengeTemplateMutationVariables>(UpdateChallengeTemplateDocument);
};
export const AddChallengeDocument = /*#__PURE__*/ gql`
    mutation addChallenge($input: AddChallengeInput!) {
  addChallenge(input: $input) {
    error {
      code
    }
    node {
      id
      versions {
        startDate
      }
    }
  }
}
    `;

export function useAddChallengeMutation() {
  return Urql.useMutation<TAddChallengeMutation, TAddChallengeMutationVariables>(AddChallengeDocument);
};
export const EditChallengeDocument = /*#__PURE__*/ gql`
    mutation editChallenge($input: EditChallengeInput!) {
  editChallenge(input: $input) {
    error {
      code
    }
    node {
      id
      versions {
        startDate
      }
    }
  }
}
    `;

export function useEditChallengeMutation() {
  return Urql.useMutation<TEditChallengeMutation, TEditChallengeMutationVariables>(EditChallengeDocument);
};
export const CreateAddChallengeProposalDocument = /*#__PURE__*/ gql`
    mutation createAddChallengeProposal($input: CreateAddChallengeProposalInput!) {
  createAddChallengeProposal(input: $input) {
    error {
      code
    }
    node {
      id
      patient {
        id
        slug
      }
    }
  }
}
    `;

export function useCreateAddChallengeProposalMutation() {
  return Urql.useMutation<TCreateAddChallengeProposalMutation, TCreateAddChallengeProposalMutationVariables>(CreateAddChallengeProposalDocument);
};
export const UpdateAddChallengeProposalDocument = /*#__PURE__*/ gql`
    mutation updateAddChallengeProposal($input: UpdateAddChallengeProposalInput!) {
  updateAddChallengeProposal(input: $input) {
    error {
      code
    }
    node {
      id
    }
  }
}
    `;

export function useUpdateAddChallengeProposalMutation() {
  return Urql.useMutation<TUpdateAddChallengeProposalMutation, TUpdateAddChallengeProposalMutationVariables>(UpdateAddChallengeProposalDocument);
};
export const ArchivePackDocument = /*#__PURE__*/ gql`
    mutation archivePack($input: ToggleChallengePackArchivedInput!) {
  toggleChallengePackArchived(input: $input) {
    error {
      code
    }
    node {
      id
      archived
    }
  }
}
    `;

export function useArchivePackMutation() {
  return Urql.useMutation<TArchivePackMutation, TArchivePackMutationVariables>(ArchivePackDocument);
};
export const CreateChallengePackDocument = /*#__PURE__*/ gql`
    mutation createChallengePack($input: CreateChallengeTemplatePackInput!) {
  createChallengeTemplatePack(input: $input) {
    error {
      code
    }
    node {
      id
    }
  }
}
    `;

export function useCreateChallengePackMutation() {
  return Urql.useMutation<TCreateChallengePackMutation, TCreateChallengePackMutationVariables>(CreateChallengePackDocument);
};
export const SendChallengePackDocument = /*#__PURE__*/ gql`
    mutation sendChallengePack($input: SendChallengePackInput!) {
  sendChallengePack(input: $input) {
    error {
      code
    }
    node {
      id
      patient {
        id
        slug
      }
    }
  }
}
    `;

export function useSendChallengePackMutation() {
  return Urql.useMutation<TSendChallengePackMutation, TSendChallengePackMutationVariables>(SendChallengePackDocument);
};
export const SendSerialPackProposalDocument = /*#__PURE__*/ gql`
    mutation sendSerialPackProposal($input: SendSerialPackProposalInput!) {
  sendSerialPackProposal(input: $input) {
    error {
      code
    }
    node {
      id
    }
  }
}
    `;

export function useSendSerialPackProposalMutation() {
  return Urql.useMutation<TSendSerialPackProposalMutation, TSendSerialPackProposalMutationVariables>(SendSerialPackProposalDocument);
};
export const UsePackCodeDocument = /*#__PURE__*/ gql`
    mutation usePackCode($input: UsePackCodeInput!) {
  usePackCode(input: $input) {
    error {
      code
    }
  }
}
    `;

export function useUsePackCodeMutation() {
  return Urql.useMutation<TUsePackCodeMutation, TUsePackCodeMutationVariables>(UsePackCodeDocument);
};
export const CopyChallengePackDocument = /*#__PURE__*/ gql`
    mutation copyChallengePack($input: CopyChallengeTemplatePackInput!) {
  copyChallengeTemplatePack(input: $input) {
    error {
      code
    }
    node {
      id
    }
  }
}
    `;

export function useCopyChallengePackMutation() {
  return Urql.useMutation<TCopyChallengePackMutation, TCopyChallengePackMutationVariables>(CopyChallengePackDocument);
};
export const ShareChallengePackWithTherapistDocument = /*#__PURE__*/ gql`
    mutation shareChallengePackWithTherapist($input: ShareChallengePackWithTherapistInput!) {
  shareChallengePackWithTherapist(input: $input) {
    error {
      code
      message
    }
    node {
      id
      approval
    }
  }
}
    `;

export function useShareChallengePackWithTherapistMutation() {
  return Urql.useMutation<TShareChallengePackWithTherapistMutation, TShareChallengePackWithTherapistMutationVariables>(ShareChallengePackWithTherapistDocument);
};
export const RespondToChallengePackShareDocument = /*#__PURE__*/ gql`
    mutation respondToChallengePackShare($input: RespondToChallengePackShareInput!) {
  respondToChallengePackShare(input: $input) {
    error {
      code
      message
    }
    node {
      id
      approval
    }
  }
}
    `;

export function useRespondToChallengePackShareMutation() {
  return Urql.useMutation<TRespondToChallengePackShareMutation, TRespondToChallengePackShareMutationVariables>(RespondToChallengePackShareDocument);
};
export const SendMessageDocument = /*#__PURE__*/ gql`
    mutation sendMessage($input: SendMessageInput!) {
  sendMessage(input: $input) {
    error {
      code
    }
    node {
      ...Message
    }
  }
}
    ${MessageFragmentDoc}`;

export function useSendMessageMutation() {
  return Urql.useMutation<TSendMessageMutation, TSendMessageMutationVariables>(SendMessageDocument);
};
export const MarkMessageAsReadDocument = /*#__PURE__*/ gql`
    mutation markMessageAsRead($input: MarkMessageAsReadInput!) {
  markMessageAsRead(input: $input) {
    error {
      code
    }
    node {
      id
      viewerReadAt
      conversation {
        ...Conversation
      }
    }
  }
}
    ${ConversationFragmentDoc}`;

export function useMarkMessageAsReadMutation() {
  return Urql.useMutation<TMarkMessageAsReadMutation, TMarkMessageAsReadMutationVariables>(MarkMessageAsReadDocument);
};
export const UserDocument = /*#__PURE__*/ gql`
    query user($id: ID!) {
  user(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUserQuery(options: Omit<Urql.UseQueryArgs<TUserQueryVariables>, 'query'>) {
  return Urql.useQuery<TUserQuery, TUserQueryVariables>({ query: UserDocument, ...options });
};
export const ViewerDocument = /*#__PURE__*/ gql`
    query viewer {
  user(id: "viewer") {
    ...Viewer
  }
}
    ${ViewerFragmentDoc}`;

export function useViewerQuery(options?: Omit<Urql.UseQueryArgs<TViewerQueryVariables>, 'query'>) {
  return Urql.useQuery<TViewerQuery, TViewerQueryVariables>({ query: ViewerDocument, ...options });
};
export const MessageChangeDocument = /*#__PURE__*/ gql`
    subscription MessageChange($conversation: ID) {
  changedMessages(conversation: $conversation) {
    __typename
    ...Message
    conversation {
      ...Conversation
    }
  }
}
    ${MessageFragmentDoc}
${ConversationFragmentDoc}`;

export function useMessageChangeSubscription<TData = TMessageChangeSubscription>(options: Omit<Urql.UseSubscriptionArgs<TMessageChangeSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<TMessageChangeSubscription, TData>) {
  return Urql.useSubscription<TMessageChangeSubscription, TData, TMessageChangeSubscriptionVariables>({ query: MessageChangeDocument, ...options }, handler);
};
export const ChallengePackSharesDocument = /*#__PURE__*/ gql`
    query challengePackShares($pack: ID!) {
  challengePackShares(pack: $pack) {
    id
    approval
    recipient {
      id
      firstName
      lastName
    }
  }
}
    `;

export function useChallengePackSharesQuery(options: Omit<Urql.UseQueryArgs<TChallengePackSharesQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengePackSharesQuery, TChallengePackSharesQueryVariables>({ query: ChallengePackSharesDocument, ...options });
};
export const PatientAlertSettingsDocument = /*#__PURE__*/ gql`
    query PatientAlertSettings($userId: ID!) {
  user(id: $userId) {
    therapistAlertConfig {
      inactivity {
        enabled
        level
        threshold
      }
    }
  }
}
    `;

export function usePatientAlertSettingsQuery(options: Omit<Urql.UseQueryArgs<TPatientAlertSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<TPatientAlertSettingsQuery, TPatientAlertSettingsQueryVariables>({ query: PatientAlertSettingsDocument, ...options });
};
export const TherapistsDocument = /*#__PURE__*/ gql`
    query therapists($first: Int, $search: String!) {
  therapists(first: $first, search: $search) {
    nodes {
      firstName
      lastName
      joined
      avatar
      id
    }
  }
}
    `;

export function useTherapistsQuery(options: Omit<Urql.UseQueryArgs<TTherapistsQueryVariables>, 'query'>) {
  return Urql.useQuery<TTherapistsQuery, TTherapistsQueryVariables>({ query: TherapistsDocument, ...options });
};
export const ChallengeTemplateNewExerciseDocument = /*#__PURE__*/ gql`
    query challengeTemplateNewExercise($id: ID!) {
  exercise(id: $id) {
    ...CreateChallengeTemplateExercise
  }
}
    ${CreateChallengeTemplateExerciseFragmentDoc}`;

export function useChallengeTemplateNewExerciseQuery(options: Omit<Urql.UseQueryArgs<TChallengeTemplateNewExerciseQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengeTemplateNewExerciseQuery, TChallengeTemplateNewExerciseQueryVariables>({ query: ChallengeTemplateNewExerciseDocument, ...options });
};
export const EditChallengeDataDocument = /*#__PURE__*/ gql`
    query editChallengeData($id: ID!) {
  challenge(id: $id) {
    ...editChallengeFragment
  }
}
    ${EditChallengeFragmentFragmentDoc}`;

export function useEditChallengeDataQuery(options: Omit<Urql.UseQueryArgs<TEditChallengeDataQueryVariables>, 'query'>) {
  return Urql.useQuery<TEditChallengeDataQuery, TEditChallengeDataQueryVariables>({ query: EditChallengeDataDocument, ...options });
};
export const ChallengePackNameDocument = /*#__PURE__*/ gql`
    query challengePackName($id: ID!) {
  challengeTemplatePack(id: $id) {
    id
    name
  }
}
    `;

export function useChallengePackNameQuery(options: Omit<Urql.UseQueryArgs<TChallengePackNameQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengePackNameQuery, TChallengePackNameQueryVariables>({ query: ChallengePackNameDocument, ...options });
};
export const ChallengeTemplateOrProposalDocument = /*#__PURE__*/ gql`
    query challengeTemplateOrProposal($id: ID!) {
  node(id: $id) {
    __typename
    id
    ... on IChallengeTemplate {
      ...editChallengeTemplate
    }
    ... on ChallengeProposal {
      approval
      editedChallenge {
        ...editChallengeFragment
      }
      author {
        id
      }
    }
  }
}
    ${EditChallengeTemplateFragmentDoc}
${EditChallengeFragmentFragmentDoc}`;

export function useChallengeTemplateOrProposalQuery(options: Omit<Urql.UseQueryArgs<TChallengeTemplateOrProposalQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengeTemplateOrProposalQuery, TChallengeTemplateOrProposalQueryVariables>({ query: ChallengeTemplateOrProposalDocument, ...options });
};
export const ActivationCodesViewDocument = /*#__PURE__*/ gql`
    query ActivationCodesView($pack: ID!, $first: Int, $last: Int, $before: String, $after: String) {
  packCodeFolders(
    pack: $pack
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      id
      createdAt
      name
      codesRevoked
      maxUseCount
      codeUsers {
        totalCount
      }
      codes(first: 1) {
        totalCount
        nodes {
          id
          value
          revoked
        }
      }
      author {
        ...Avatar
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${AvatarFragmentDoc}`;

export function useActivationCodesViewQuery(options: Omit<Urql.UseQueryArgs<TActivationCodesViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TActivationCodesViewQuery, TActivationCodesViewQueryVariables>({ query: ActivationCodesViewDocument, ...options });
};
export const FolderDocument = /*#__PURE__*/ gql`
    query Folder($id: ID!, $after: String, $before: String, $first: Int, $last: Int) {
  packCodeFolder(folder: $id) {
    id
    codes(after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        revoked
        maxUseCount
        value
        codeUsers {
          totalCount
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;

export function useFolderQuery(options: Omit<Urql.UseQueryArgs<TFolderQueryVariables>, 'query'>) {
  return Urql.useQuery<TFolderQuery, TFolderQueryVariables>({ query: FolderDocument, ...options });
};
export const ChallengePackViewDocument = /*#__PURE__*/ gql`
    query ChallengePackView($packId: ID!) {
  challengeTemplatePack(id: $packId) {
    id
    name
    archived
    description
    type
    sharePending
    codeFolders(onlyActive: true) {
      totalCount
    }
    challenges {
      ...calendarFragment
      id
      amount
      amountUnit
      category
      serialDay
      serialDayIndex
      exercise {
        localizations(locale: "best-fit") {
          title
          subtitle
          movementNameSingular
          movementNamePlural
          icon {
            formats {
              encoding
              fileName
              height
              width
            }
          }
        }
      }
      extraInstructions
      scheduleTemplate
      series
    }
  }
}
    ${CalendarFragmentFragmentDoc}`;

export function useChallengePackViewQuery(options: Omit<Urql.UseQueryArgs<TChallengePackViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengePackViewQuery, TChallengePackViewQueryVariables>({ query: ChallengePackViewDocument, ...options });
};
export const SerialPackProposalsDocument = /*#__PURE__*/ gql`
    query SerialPackProposals($packId: ID!) {
  serialPackProposals(packId: $packId) {
    id
    approval
    pack {
      id
    }
  }
}
    `;

export function useSerialPackProposalsQuery(options: Omit<Urql.UseQueryArgs<TSerialPackProposalsQueryVariables>, 'query'>) {
  return Urql.useQuery<TSerialPackProposalsQuery, TSerialPackProposalsQueryVariables>({ query: SerialPackProposalsDocument, ...options });
};
export const ChallengePackShareDocument = /*#__PURE__*/ gql`
    query ChallengePackShare($packId: ID!) {
  challengePackShare(pack: $packId) {
    id
    approval
    packName
    author {
      id
      firstName
      lastName
    }
  }
}
    `;

export function useChallengePackShareQuery(options: Omit<Urql.UseQueryArgs<TChallengePackShareQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengePackShareQuery, TChallengePackShareQueryVariables>({ query: ChallengePackShareDocument, ...options });
};
export const ChallengePacksViewDocument = /*#__PURE__*/ gql`
    query challengePacksView($archived: Boolean!, $type: String) {
  challengeTemplatePacks(archived: $archived, type: $type) {
    id
    name
    description
    archived
    sharePending
    type
    challenges {
      id
    }
  }
}
    `;

export function useChallengePacksViewQuery(options: Omit<Urql.UseQueryArgs<TChallengePacksViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengePacksViewQuery, TChallengePacksViewQueryVariables>({ query: ChallengePacksViewDocument, ...options });
};
export const ContactsDocument = /*#__PURE__*/ gql`
    query contacts($first: Int, $search: String) {
  contacts(first: $first, search: $search) {
    nodes {
      firstName
      lastName
      joined
      avatar
      id
    }
  }
}
    `;

export function useContactsQuery(options?: Omit<Urql.UseQueryArgs<TContactsQueryVariables>, 'query'>) {
  return Urql.useQuery<TContactsQuery, TContactsQueryVariables>({ query: ContactsDocument, ...options });
};
export const MessageHistoryDocument = /*#__PURE__*/ gql`
    query MessageHistory($conversation: ID!, $first: Int, $after: String, $before: String, $last: Int, $around: String, $aroundLimit: Int) {
  messages(
    conversation: $conversation
    first: $first
    after: $after
    before: $before
    last: $last
    around: $around
    aroundLimit: $aroundLimit
  ) {
    nodes {
      ...Message
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    ${MessageFragmentDoc}`;

export function useMessageHistoryQuery(options: Omit<Urql.UseQueryArgs<TMessageHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<TMessageHistoryQuery, TMessageHistoryQueryVariables>({ query: MessageHistoryDocument, ...options });
};
export const ConversationDocument = /*#__PURE__*/ gql`
    query Conversation($contact: ID!) {
  user(id: $contact) {
    ...User
    viewerConversation {
      id
      oldestUnreadMessage {
        id
      }
    }
  }
}
    ${UserFragmentDoc}`;

export function useConversationQuery(options: Omit<Urql.UseQueryArgs<TConversationQueryVariables>, 'query'>) {
  return Urql.useQuery<TConversationQuery, TConversationQueryVariables>({ query: ConversationDocument, ...options });
};
export const ConversationListDocument = /*#__PURE__*/ gql`
    query ConversationList($first: Int!, $after: String) {
  conversations(first: $first, after: $after) {
    nodes {
      ...Conversation
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ConversationFragmentDoc}`;

export function useConversationListQuery(options: Omit<Urql.UseQueryArgs<TConversationListQueryVariables>, 'query'>) {
  return Urql.useQuery<TConversationListQuery, TConversationListQueryVariables>({ query: ConversationListDocument, ...options });
};
export const ChallengeViewDocument = /*#__PURE__*/ gql`
    query ChallengeView($id: ID!) {
  challenge(id: $id) {
    __typename
    id
    ...calendarFragment
  }
}
    ${CalendarFragmentFragmentDoc}`;

export function useChallengeViewQuery(options: Omit<Urql.UseQueryArgs<TChallengeViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengeViewQuery, TChallengeViewQueryVariables>({ query: ChallengeViewDocument, ...options });
};
export const ChallengeProposalViewDocument = /*#__PURE__*/ gql`
    query ChallengeProposalView($id: ID!) {
  node(id: $id) {
    __typename
    id
    ...calendarFragment
  }
}
    ${CalendarFragmentFragmentDoc}`;

export function useChallengeProposalViewQuery(options: Omit<Urql.UseQueryArgs<TChallengeProposalViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TChallengeProposalViewQuery, TChallengeProposalViewQueryVariables>({ query: ChallengeProposalViewDocument, ...options });
};
export const GroupViewDocument = /*#__PURE__*/ gql`
    query GroupView($groupId: ID!, $first: Int!, $after: String, $before: String) {
  group(id: $groupId) {
    id
    name
    memberCount
    members(first: $first, after: $after, before: $before) {
      totalCount
      nodes {
        id
        slug
        avatar
        firstName
        lastName
        joined
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    organisationPermissions
    organisation {
      id
      name
      viewerPermissions
    }
  }
}
    `;

export function useGroupViewQuery(options: Omit<Urql.UseQueryArgs<TGroupViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TGroupViewQuery, TGroupViewQueryVariables>({ query: GroupViewDocument, ...options });
};
export const OrganisationDocument = /*#__PURE__*/ gql`
    query Organisation($id: ID!) {
  organisation(id: $id) {
    id
    name
    viewerPermissions
  }
}
    `;

export function useOrganisationQuery(options: Omit<Urql.UseQueryArgs<TOrganisationQueryVariables>, 'query'>) {
  return Urql.useQuery<TOrganisationQuery, TOrganisationQueryVariables>({ query: OrganisationDocument, ...options });
};
export const OrganisationMembersDocument = /*#__PURE__*/ gql`
    query OrganisationMembers($orgId: ID!, $first: Int!, $after: String) {
  organisation(id: $orgId) {
    id
    groups(first: $first, after: $after) {
      nodes {
        id
        name
        memberCount
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

export function useOrganisationMembersQuery(options: Omit<Urql.UseQueryArgs<TOrganisationMembersQueryVariables>, 'query'>) {
  return Urql.useQuery<TOrganisationMembersQuery, TOrganisationMembersQueryVariables>({ query: OrganisationMembersDocument, ...options });
};
export const OrganisationsDocument = /*#__PURE__*/ gql`
    query Organisations($first: Int!, $after: String, $onlyIfMembership: Boolean) {
  organisations(first: $first, after: $after, onlyIfMembership: $onlyIfMembership) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

export function useOrganisationsQuery(options: Omit<Urql.UseQueryArgs<TOrganisationsQueryVariables>, 'query'>) {
  return Urql.useQuery<TOrganisationsQuery, TOrganisationsQueryVariables>({ query: OrganisationsDocument, ...options });
};
export const GetStatDetailsDocument = /*#__PURE__*/ gql`
    query getStatDetails($id: ID!) {
  challenge(id: $id) {
    ...calendarFragment
    id
    totalDone
    category
    versions {
      versionIndex
      historicalRRule
      amount
      series
      amountUnit
      exercise {
        id
        exerciseTypes
        localizations(locale: "best-fit") {
          title
          subtitle
          movementNameSingular
          movementNamePlural
          isoLanguage
          icon {
            id
            formats {
              fileName
              encoding
              height
              width
            }
          }
        }
      }
    }
  }
}
    ${CalendarFragmentFragmentDoc}`;

export function useGetStatDetailsQuery(options: Omit<Urql.UseQueryArgs<TGetStatDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<TGetStatDetailsQuery, TGetStatDetailsQueryVariables>({ query: GetStatDetailsDocument, ...options });
};
export const StatCheckInDataDocument = /*#__PURE__*/ gql`
    query statCheckInData($id: ID!, $dates: String!) {
  challenge(id: $id) {
    versions(activeAt: $dates) {
      historicalRRule
      amount
      series
      amountUnit
      exercise {
        localizations(locale: "best-fit") {
          movementNameSingular
          movementNamePlural
        }
      }
      checkIns(dates: $dates) {
        dueDate
        amounts
        feedback
        feedbackPositive
        feedbackTypes
      }
    }
  }
}
    `;

export function useStatCheckInDataQuery(options: Omit<Urql.UseQueryArgs<TStatCheckInDataQueryVariables>, 'query'>) {
  return Urql.useQuery<TStatCheckInDataQuery, TStatCheckInDataQueryVariables>({ query: StatCheckInDataDocument, ...options });
};
export const StatListViewDocument = /*#__PURE__*/ gql`
    query StatListView($userId: ID!, $activeAt: String, $inactiveAt: String, $authorId: String, $patientId: String, $versionRange: String!) {
  pageOwner: user(id: $userId) {
    firstName
    lastName
    id
    slug
  }
  challenges(
    activeAt: $activeAt
    inactiveAt: $inactiveAt
    patientId: $patientId
    authorId: $authorId
  ) {
    id
    totalDone
    category
    versions(activeAt: $versionRange) {
      versionIndex
      historicalRRule
      amount
      series
      amountUnit
      exercise {
        id
        exerciseTypes
        localizations(locale: "best-fit") {
          title
          subtitle
          movementNameSingular
          movementNamePlural
          isoLanguage
          icon {
            id
            formats {
              fileName
              encoding
              height
              width
            }
          }
          video {
            ... on Asset {
              id
              formats {
                fileName
                encoding
                height
                width
              }
            }
            ... on PlatformVideo {
              videoId
              platform
            }
          }
        }
      }
      checkIns(dates: $versionRange) {
        amounts
        dueDate
        feedbackTypes
        feedbackPositive
        feedback
      }
    }
  }
  assignedQuestions(
    activeAt: $activeAt
    patientId: $patientId
    authorId: $authorId
  ) {
    id
  }
}
    `;

export function useStatListViewQuery(options: Omit<Urql.UseQueryArgs<TStatListViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TStatListViewQuery, TStatListViewQueryVariables>({ query: StatListViewDocument, ...options });
};
export const PatientCalendarFilteredViewDocument = /*#__PURE__*/ gql`
    query patientCalendarFilteredView($entityId: ID!) {
  node(id: $entityId) {
    ...calendarFragment
  }
}
    ${CalendarFragmentFragmentDoc}`;

export function usePatientCalendarFilteredViewQuery(options: Omit<Urql.UseQueryArgs<TPatientCalendarFilteredViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TPatientCalendarFilteredViewQuery, TPatientCalendarFilteredViewQueryVariables>({ query: PatientCalendarFilteredViewDocument, ...options });
};
export const PatientCalendarViewDocument = /*#__PURE__*/ gql`
    query patientCalendarView($activeAt: String!) {
  challenges(activeAt: $activeAt) {
    ...calendarFragment
  }
  assignedQuestions(activeAt: $activeAt) {
    ...calendarFragment
  }
}
    ${CalendarFragmentFragmentDoc}`;

export function usePatientCalendarViewQuery(options: Omit<Urql.UseQueryArgs<TPatientCalendarViewQueryVariables>, 'query'>) {
  return Urql.useQuery<TPatientCalendarViewQuery, TPatientCalendarViewQueryVariables>({ query: PatientCalendarViewDocument, ...options });
};
export const PatientPlanningDocument = /*#__PURE__*/ gql`
    query PatientPlanning($date: String!) {
  challenges(first: 1) {
    id
  }
  assignedQuestions(plannedOn: $date) {
    id
    localizations(locale: "best-fit") {
      locale
      title
      description
    }
    responses(dates: $date) {
      value
      date
    }
  }
}
    `;

export function usePatientPlanningQuery(options: Omit<Urql.UseQueryArgs<TPatientPlanningQueryVariables>, 'query'>) {
  return Urql.useQuery<TPatientPlanningQuery, TPatientPlanningQueryVariables>({ query: PatientPlanningDocument, ...options });
};
export const TherapistDashboardAlertsDocument = /*#__PURE__*/ gql`
    query TherapistDashboardAlerts {
  therapistPatientAlerts {
    patient {
      id
      slug
      firstName
      lastName
      roles
      avatar
    }
    alerts {
      ...TherapistDashboardAlert
    }
  }
}
    ${TherapistDashboardAlertFragmentDoc}`;

export function useTherapistDashboardAlertsQuery(options?: Omit<Urql.UseQueryArgs<TTherapistDashboardAlertsQueryVariables>, 'query'>) {
  return Urql.useQuery<TTherapistDashboardAlertsQuery, TTherapistDashboardAlertsQueryVariables>({ query: TherapistDashboardAlertsDocument, ...options });
};
export const TherapistDashboardPlanningDocument = /*#__PURE__*/ gql`
    query TherapistDashboardPlanning {
  therapistPatientPlanning(withFuture: true) {
    date
    patient {
      id
      slug
      firstName
      lastName
      roles
      avatar
    }
  }
}
    `;

export function useTherapistDashboardPlanningQuery(options?: Omit<Urql.UseQueryArgs<TTherapistDashboardPlanningQueryVariables>, 'query'>) {
  return Urql.useQuery<TTherapistDashboardPlanningQuery, TTherapistDashboardPlanningQueryVariables>({ query: TherapistDashboardPlanningDocument, ...options });
};